/**
 * Filipino (Tagalog).
 *
 * Ang mga susi ay galing sa `cs.js`. Kapag may nawawala, lumalabas ang tekstong
 * Ingles (at kung wala rin iyon, Czech), para halata ang butas.
 *
 * Hindi pa nababasa ang pagsasaling ito ng isang trans na taong nagsasalita ng
 * Filipino. Mas mabigat dito kaysa saanman ang bokabularyo ng transition at ang
 * paraan ng pagtawag sa tao: kung may tunog na mali, sabihin at babaguhin namin.
 */
const tl = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Bumalik',
  'obecne.hledat': 'Maghanap',
  'obecne.nacitani': 'Naglo-load…',
  'obecne.zrusit': 'Kanselahin',
  'obecne.ulozit': 'I-save',
  'obecne.odeslat': 'Ipadala',
  'obecne.vice': 'Ipakita lahat',
  'obecne.jazyk': 'Wika',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Ligtas na espasyo para sa trans community, kung saan puwede kang magsalita nang tapat, humanap ng tulong at makaramdam ng suporta.',
  'auth.prihlaseni': 'Mag-sign in',
  'auth.registrace': 'Mag-sign up',
  'auth.email': 'Email',
  'auth.heslo': 'Password',
  'auth.emailPriklad': 'ikaw@halimbawa.com',
  'auth.prihlasitSe': 'Mag-sign in',
  'auth.prihlasuji': 'Nagsa-sign in…',
  'auth.zapomenuteHeslo': 'Nakalimutan mo ang password?',
  'auth.presGoogle': 'Mag-sign in gamit ang Google',
  'auth.spatneUdaje': 'Mali ang email o password',
  'auth.uspech': 'Naka-sign in ka na.',
  'auth.googleChyba': 'Hindi natuloy ang pag-sign in gamit ang Google',
  'auth.obnoveniHesla': 'Pag-reset ng password',
  'auth.obnoveniOdeslano': 'Kung nakarehistro ang email, makakatanggap ka ng link para sa pag-reset ng password.',
  'auth.zpetNaPrihlaseni': 'Balik sa pag-sign in',
  'auth.odeslatOdkaz': 'Ipadala ang link',
  'auth.obnoveniChyba': 'Hindi naipadala ang email. Subukan ulit.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Isa pang hakbang: ang code mo',
  'auth.jesteKodPopis': 'Buksan ang authenticator app mo at kopyahin ang anim na numerong nakalagay para sa Bloom.',
  'auth.kod': 'Code',
  'auth.zalozniKodNapoveda': 'Wala ang telepono mo? Ilagay ang isa sa mga backup code na na-save mo noong binuksan mo ito.',
  'auth.potvrdit': 'Kumpirmahin',
  'auth.overuji': 'Tinitingnan…',
  'auth.kodNesedi': 'Mali ang code na iyon',
  'auth.zalozniDochazeji': (p) => `${p.pocet} na lang ang natitira mong backup code. Gumawa ng bago sa profile mo.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Paano i-install ang Bloom sa telepono mo',
  'auth.krokyAndroid': [
      'Buksan ang page na ito sa Chrome',
      'Pindutin ang tatlong tuldok (⋮) sa kanang itaas',
      'Piliin ang “Add to Home screen” o “Install app”',
      'Kumpirmahin ang pag-install',
    ],
  'auth.krokyIos': [
      'Buksan ang page na ito sa Safari',
      'Pindutin ang share icon (□↑) sa ibabang bar',
      'Mag-scroll pababa at piliin ang “Add to Home Screen”',
      'Kumpirmahin sa pamamagitan ng “Add”',
    ],
  'auth.seznamChranene': [
      { silne: 'Walang tungkol sa mga miyembro na pampubliko.', text: 'Ang mga profile, kuwento, alok, tanong, larawan at avatar ay ibinibigay lang sa mga naka-sign in. Wala rito ang puwedeng i-download o kalapin nang walang account.' },
      { silne: 'Walang nakakaalam ng password mo', text: '— kahit kami. Naka-imbak ito bilang bcrypt hash, kung saan hindi na mababalikan ang orihinal.' },
      { silne: 'Naka-encrypt ang mga pribadong mensahe at attachment', text: '(AES + integrity check) sa disk ng server. Ang sinumang makakakuha ng backup o ng disk ay makakabasa lang ng walang kabuluhang mga karakter.' },
      { silne: 'Kusang nabubura ang mga mensahe', text: 'pagkalipas ng takdang panahon (90 araw bilang default), pati na ang mga voice note at larawan. Ang wala rito ay hindi puwedeng tumagas.' },
      { silne: 'Pribado ang yugto ng transition mo', text: 'hangga\'t hindi mo ito mismo inilalathala. Walang ibang nakakakita ng mga hakbang na tinsek mo sa Gabay.' },
      { silne: 'Ang email at telepono', text: 'ay hindi kailanman ipinapakita sa ibang miyembro.' },
      { silne: '', text: 'Protektado ang pag-sign in laban sa paghula ng password sa pamamagitan ng paglilimita sa bilang ng pagsubok.' },
      { silne: 'End-to-end encryption ng mga mensahe.', text: 'Kapag binuksan mo ito, ang teksto at mga attachment ay ine-encrypt sa sarili mong browser at basura lang ang natatanggap ng server. Ang susi ay binubuksan ng password mo at hindi umaalis sa device mo — kaya hindi rin namin mabasa ang laman, kahit hilingin pa ng korte. Ang kapalit: kapag nakalimutan mo ang password mo, hindi mo na rin mababasa ang mga lumang mensahe.' },
      { silne: '', text: 'Hindi nananatili ang pagiging naka-sign in: nila-log out ka ng Bloom kapag isinara mo ang window at pagkatapos ng sampung minutong walang ginagawa.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Metadata', text: '— sino ang sumulat kanino at kailan — ay kailangang malaman ng server para maihatid ang mensahe. Hindi ito itinatago ng end-to-end encryption, at hindi rin ito kayang itago ng Signal.' },
      { silne: '', text: 'Web app ang Bloom, kaya kinukuha nito ang encryption code sa server namin sa tuwing bubuksan mo ito. Ang sinumang makakuha ng server ay puwedeng, sa teorya, maghatid ng binagong code. Signed app lang mula sa isang store ang nagpoprotekta laban doon — kaya may ganoon ang Signal at wala ang web version.' },
      { silne: 'Ang mga profile', text: '— palayaw, bio, avatar — ay hindi puwedeng i-encrypt, dahil kailangang ipakita ng server ang mga ito sa ibang miyembro.' },
      { silne: '', text: 'Ang mga mensaheng bago mo binuksan ang encryption ay naka-encrypt lang sa disk ng server, hindi end-to-end.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Gumagana ang Bloom parang app, kahit offline. Laging napapanahon ang data mo.',
  'auth.zabezpeceniTitulek': 'Paano pinoprotektahan ang Bloom',
  'auth.zabezpeceniUvod': 'Espasyo ang Bloom para sa trans community, kaya sensitibong bagay ang nagtatagpo rito. Nasa ibaba '
      + 'ang ginagawa namin para protektahan ang mga iyon — at ang hindi namin kaya — nang walang pagpapaganda.',
  'auth.coJeChranene': 'Ano ang protektado',
  'auth.coNeumime': 'Ang hindi kaya ng Bloom — at tama lang na sabihin ito',
  'auth.zabezpeceniZaver': 'Kung may tanong ka tungkol sa privacy o may nakita kang kahinaan, gamitin ang “Mag-ulat ng problema” sa ibaba. Seryoso namin itong tinitingnan.',
  'auth.mvp': 'Nasa unang bersyon pa ang Bloom at patuloy naming pinapabuti kasama ang komunidad. '
      + 'Kung may nakita kang bug o may ideya ka, ikagagalak naming marinig ito.',
  'auth.nahlasitProblem': 'Mag-ulat ng problema',
  'auth.clenu': () => 'miyembro',
  'auth.prispevku': () => 'post',
  'auth.odborniku': () => 'propesyonal',
  'auth.nabidek': () => 'alok',

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Palayaw (natatangi)',
  'reg.prezdivkaPriklad': 'Hindi bababa sa 3 karakter',
  'reg.telefon': 'Numero ng telepono',
  'reg.volitelne': '(opsyonal)',
  'reg.heslo': 'Password',
  'reg.hesloZnovu': 'Ulitin ang password',
  'reg.zajmeno': 'Panghalip',
  'reg.oMne': 'Tungkol sa akin',
  'reg.oMnePriklad': 'Ilang salita tungkol sa iyo…',
  'reg.registrovat': 'Gumawa ng account',
  'reg.registruji': 'Ginagawa ang account…',
  'reg.presGoogle': 'Mag-sign up gamit ang Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'O mag-upload ng sarili mong larawan',
  'reg.nahratFoto': 'Mag-upload ng larawan',
  'reg.vlastni': 'Sarili',
  'reg.zeme': 'Bansa',
  'reg.kraj': 'Rehiyon',
  'reg.nechciUvadet': 'Ayaw kong sabihin',
  'reg.cesko': 'Czechia',
  'reg.svet': 'Iba pang bahagi ng mundo',

  // skupiny avatarů
  'reg.avatarFem': 'Pambabae',
  'reg.avatarMask': 'Panlalaki',
  'reg.avatarNeutr': 'Neutral',
  'reg.avatarZvirata': 'Mga hayop',

  // komunitní heslo
  'reg.komunitniHeslo': 'Password ng komunidad',
  'reg.komunitniHesloPriklad': 'Ilagay ang password ng komunidad…',
  'reg.komunitniHesloPopis': 'Pribadong espasyo ang Bloom para sa trans community. May makakapagbigay sa iyo ng password mula sa komunidad.',
  'reg.napisAdminovi': 'Kung wala kang kakilala, sumulat sa admin sa',
  'reg.nevimHeslo': 'Hindi ko alam ang password ng komunidad',
  'reg.jakZiskat': 'Ang password ng komunidad ang nagpoprotekta sa pribadong espasyong ito. Paano ito makukuha:',
  'reg.krok1': '1. Magpadala ng email sa',
  'reg.krok2': '2. Magpakilala nang maikli at sabihin kung paano mo nalaman ang Bloom',
  'reg.krok3': '3. Sasagot ang administrator sa lalong madaling panahon',

  // kontrola hesla
  'reg.hesloKratke': 'Kailangang hindi bababa sa 8 karakter ang password',
  'reg.hesloMale': 'Kailangang may maliit na titik ang password',
  'reg.hesloVelke': 'Kailangang may malaking titik ang password',
  'reg.hesloCislo': 'Kailangang may numero ang password',
  'reg.hesloZnak': 'Kailangang may espesyal na karakter ang password (!@#$%…)',
  'reg.pozadavek8': 'Hindi bababa sa 8 karakter',
  'reg.pozadavekVelke': 'Malaking titik',
  'reg.pozadavekCislo': 'Numero',
  'reg.pozadavekZnak': 'Espesyal na karakter (!@#$%)',
  'reg.hesloNesouhlasi': 'Hindi magkatugma ang mga password',
  'reg.prezdivkaKratka': 'Kailangang hindi bababa sa 3 karakter ang palayaw',
  'reg.hesloPovinne': 'Kailangan ang password ng komunidad',
  'reg.hotovo': 'Nagawa na ang account. Tingnan ang email mo para kumpirmahin ito.',
  'reg.fotoVelka': 'Masyadong malaki ang larawan (max 2 MB)',
  'reg.chyba': 'Hindi natuloy ang pag-sign up',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Walang kailangang maging perpekto rito. Espasyo ang Bloom kung saan puwedeng maging sarili ang lahat — '
      + 'kung saan puwede mong ibahagi ang karanasan mo, magtanong at tumulong sa iba. Walang paghusga at walang pagtatangi.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · isinalin mula sa Czech',
  'domu.vitej': 'Maligayang pagdating,',
  'domu.vCislech': 'Ang Bloom sa mga numero',
  'domu.noveVKomunite': 'Bago ka rito?',
  'domu.noveVKomunitePopis1': 'Hindi mo kailangang magpakita. Hindi mo kailangan ng larawan. Hindi mo kailangang mag-out.',
  'domu.noveVKomunitePopis2': 'Espasyo ang Bloom kung saan puwede kang magsimula sa sarili mong bilis.',
  'domu.rozcestnik1': 'Unang beses ko rito',
  'domu.rozcestnik2': 'Hindi ko alam kung saan magsisimula',
  'domu.rozcestnik3': 'Gusto kong manatiling anonymous',
  'domu.rozcestnik4': 'Naghahanap ako ng propesyonal',
  'domu.rozcestnik5': 'Gusto ko lang basahin ang mga kuwento ng iba',
  'domu.otazky': 'May tanong, o gusto mong malaman pa? Sumulat sa amin sa',
  'domu.doporucujeme': 'Inirerekomenda',
  'domu.odbornici': 'Mga propesyonal',
  'domu.noviClenove': 'Mga bagong miyembro ng komunidad',
  'domu.zadniNovi': 'Wala pang bagong miyembro',
  'domu.nejnovejsiOtazky': 'Pinakabagong mga tanong',
  'domu.zadneOtazky': 'Wala pang tanong.',
  'domu.nejlepeHodnoceni': 'Pinakamataas ang rating na mga propesyonal',
  'domu.zadniHodnoceni': 'Wala pang propesyonal na may rating',
  'domu.zadneAktuality': 'Wala pang balita',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Ialok ang kaya mo at kumuha ng tulong sa iba.',
  'domu.dlazdice.specialists': 'Maghanap ng beripikadong propesyonal, mula psychologist hanggang plastic surgeon.',
  'domu.dlazdice.legal': 'Legal na tulong, mga artikulo at sagot sa mga tanong mo.',
  'domu.dlazdice.nearby': 'Mga serbisyo at propesyonal malapit sa iyo.',

  // počty
  'domu.pocetClenu': () => 'miyembro ng komunidad',
  'domu.pocetZkusenosti': () => 'ibinahaging kuwento',
  'domu.pocetOdborniku': () => 'beripikadong propesyonal',
  'domu.pocetNabidek': () => 'alok ng tulong',

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Home',
  'nav.news': 'Balita',
  'nav.stories': 'Mga kuwento ng komunidad',
  'nav.mapaSveta': 'Mapa ng mundo',
  'nav.support': 'Tulungan ang isa\'t isa',
  'nav.specialists': 'Mga propesyonal na trans-friendly',
  'nav.legal': 'Legal na tulong',
  'nav.pageants': 'Mga pageant',
  'nav.nearby': 'Malapit sa akin',
  'nav.hledat': 'Maghanap sa Bloom',
  'nav.hledatPlaceholder': 'Maghanap ng tao, propesyonal, artikulo…',
  'nav.zpravy': 'Mga mensahe',
  'nav.profil': 'Profile ko',
  'nav.mojeCesta': 'Ang paglalakbay ko',
  'nav.administrace': 'Administrasyon',
  'nav.odhlasit': 'Mag-log out',
  'nav.vsechnyVysledky': (p) => `Ipakita lahat ng resulta para sa “${p.dotaz}”`,
  'nav.overEmail': 'Kumpirmahin ang email mo',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Ang Bloom sa buong mundo',
  'svet.podtitulek': 'Pumili ng bansa at tingnan ang naipon doon ng komunidad.',
  'svet.hledatZemi': 'Maghanap ng bansa…',
  'svet.vsechnyZeme': 'Lahat ng bansa',
  'svet.jenSObsahem': 'Mga bansang may laman lang',
  'svet.nicNenalezeno': 'Walang bansang tumutugma.',
  'svet.zaznamu': (p) => `${p.pocet} entry`,
  'svet.prazdnaZeme': 'Wala pa',
  'svet.kontinent': 'Kontinente',
  'svet.celySvet': 'Buong mundo',
  'svet.vse': 'Lahat',
  'svet.zacniDomovem': 'Magsimula sa pagpili ng bansang tinatawag mong tahanan. Puwede ka ring pumili sa listahan sa ilalim ng mapa.',
  'svet.zkoumej': 'Pumili ng bansa at tingnan ang mayroon doon ang Bloom. Maglibot kahit saan mo gusto — '
      + 'hindi nito babaguhin ang bansang tinitirhan mo.',
  'svet.domov': 'Tahanan',
  'svet.zrusitDomov': 'Alisin ang bansang tahanan',
  'svet.nastavitDomov': 'Itakda bilang bansang tahanan',
  'svet.zeSveta': 'Mula sa buong mundo',
  'svet.coSeChysta': 'Paparating',
  'svet.souteze': 'Mga pageant na bukas ang rehistrasyon',
  'svet.noveOrganizace': 'Mga bagong organisasyon',
  'svet.kdeJizNeco': 'Kung saan may laman na ang Bloom',
  'svet.hledatZemiPopisek': 'Maghanap ng bansa',
  'svet.nicNeodpovida': 'Walang tumutugma. Subukan ang ibang paghahanap.',
  'svet.napovedaKMape': 'Hilahin ang mapa para igalaw ito at mag-zoom gamit ang gulong o ang mga button. Hindi mo '
      + 'kailangang gamitin ito — nasa ibaba ang paghahanap at ang buong listahan ng mga bansa.',
  'svet.tvujBloom': (p) => `Ang Bloom mo sa ${p.zeme}`,
  'svet.tvojeDomovska': 'ang bansang tahanan mo',
  'svet.zemi': (p) => `${p.pocet} bansa`,
  'svet.chyba': 'Hindi na-load ang mga bansa. Paki-reload ang page.',
  'svet.pocet.specialists': (p) => `${p.pocet} propesyonal`,
  'svet.pocet.organizations': (p) => `${p.pocet} organisasyon`,
  'svet.pocet.events': (p) => `${p.pocet} kaganapan`,
  'svet.pocet.pageants': (p) => `${p.pocet} pageant`,
  'svet.pocet.resources': (p) => `${p.pocet} sanggunian`,

  // světadíly
  'kontinent.europe': 'Europa',
  'kontinent.asia': 'Asya',
  'kontinent.africa': 'Aprika',
  'kontinent.north_america': 'Hilagang Amerika',
  'kontinent.south_america': 'Timog Amerika',
  'kontinent.oceania': 'Oceania',
  'kontinent.antarctica': 'Antarctica',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Mga trans pageant mula sa buong mundo. Nasa itaas ang mga puwede mo pang salihan.',
  'souteze.hledat': 'Maghanap ng pageant…',
  'souteze.zadne': 'Wala pa kaming pageant. May alam ka ba? Magpadala ng suhestiyon.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Buksan ang ${p.zeme}`,
  'nahled.zavrit': 'Isara ang preview',
  'nahled.jenInformace': 'Sa ngayon impormasyon lang tungkol sa bansa ang mayroon kami.',
  'nahled.zatimNic': 'Wala pa kaming kontak, organisasyon o kaganapan dito. May alam ka? Magpadala ng suhestiyon.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Ang Bloom sa ${p.zeme}`,
  'zeme.podtitulek': (p) => `Ang naipon ng komunidad sa ${p.zeme}.`,
  'zeme.prazdna': 'Nagsisimula pa lang ang Bloom dito. Puwede kang maging una na magdagdag ng kahit ano.',
  'zeme.mapaSveta': 'Mapa ng mundo',
  'zeme.navrhnout': 'Magmungkahi ng entry',
  'zeme.domovska': 'Ang bansang tahanan mo',
  'zeme.nastavitDomovskou': 'Itakda bilang bansang tahanan',
  'zeme.kdeToJe': 'Saan ito matatagpuan',
  'zeme.coTuBude': 'Ano ang makikita mo rito',
  'zeme.zatimPrazdne': 'wala pa',
  'zeme.pripravujeme': 'malapit nang dumating',
  'zeme.zobrazitVse': (p) => `Ipakita lahat (${p.pocet})`,
  'zeme.rosteTitulek': 'Lumalago pa lang ang Bloom dito',
  'zeme.rostePopis': 'Wala pa kaming anuman dito. May alam ka bang organisasyon, kaganapan o '
      + 'kapaki-pakinabang na kontak? Magpadala ng suhestiyon — dadaan ito sa pagsusuri at lalabas dito.',
  'zeme.jinouZemi': 'Maglibot sa ibang bansa',
  'zeme.bezKontaktu': 'Wala pa kaming kontak o organisasyon dito.',
  'zeme.bezKontaktuPopis': 'May kilala ka ba o may alam kang kapaki-pakinabang dito? Magpadala ng suhestiyon — '
      + 'dadaan ito sa pagsusuri at lalabas dito.',
  'zeme.neznama': 'Hindi namin kilala ang bansang iyon.',
  'zeme.chyba': 'Hindi na-load ang bansa.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Mga doktor at klinika',
  'sekce.specialists.popis': 'Mga doktor, klinika at iba pang propesyonal na may karanasan ang komunidad.',
  'sekce.organizations': 'Mga organisasyon',
  'sekce.organizations.popis': 'Mga samahan, non-profit at support group.',
  'sekce.events': 'Mga kaganapan',
  'sekce.events.popis': 'Mga pagtitipon, Pride, workshop at kumperensiya.',
  'sekce.pageants': 'Mga pageant',
  'sekce.pageants.popis': 'Mga trans pageant at ang mga petsa nito.',
  'sekce.resources': 'Mga sanggunian',
  'sekce.resources.popis': 'Praktikal na impormasyon para sa bansang ito.',
  'sekce.community': 'Komunidad',
  'sekce.community.popis': 'Mga tao at grupo sa bansang ito.',
  'sekce.legal': 'Legal na tulong',
  'sekce.legal.popis': 'Impormasyon at suporta para sa trans community',
  'sekce.support': 'Tulungan ang isa\'t isa',
  'sekce.support.popis': 'Ialok ang kaya mo at kumuha ng tulong sa ibang miyembro ng komunidad',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Maghanap sa bansang ito…',
  'vypis.vsechnyKategorie': 'Lahat ng kategorya',
  'vypis.kategorie': 'Kategorya',
  'vypis.celaZeme': 'Buong bansa',
  'vypis.navrhnout': 'Magmungkahi',
  'vypis.nicNeodpovida': 'Walang tumutugma. Subukan ang ibang paghahanap o alisin ang filter.',
  'vypis.zadneZaznamy': (p) => `Wala pa kaming entry sa ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} entry`,
  'vypis.predchozi': 'Nakaraan',
  'vypis.dalsi': 'Susunod',
  'vypis.chyba': 'Hindi na-load ang mga entry.',
  'vypis.neznamyDruh': 'Hindi namin kilala ang ganoong uri ng entry.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Balik sa ${p.zeme}`,
  'detail.kontakty': 'Mga kontak at link',
  'detail.podrobnosti': 'Mga detalye',
  'detail.zacatek': 'Magsisimula',
  'detail.termin': 'Petsa',
  'detail.uzaverka': 'Huling araw ng rehistrasyon',
  'detail.prihlaska': 'Rehistrasyon',
  'detail.strankaAkce': 'Page ng kaganapan',
  'detail.web': 'Website',
  'detail.konec': 'Magtatapos',
  'detail.stavRocniku': 'Katayuan ng taon',
  'detail.oblasti': 'Mga larangan ng trabaho',
  'detail.coNabizi': 'Ano ang inaalok nila',
  'detail.kategorie': 'Mga kategorya',
  'detail.jazyky': 'Mga wika',
  'detail.vitezove': 'Mga naunang nanalo',
  'detail.kdoSeMuze': 'Sino ang puwedeng sumali',
  'detail.poradatel': 'Nag-oorganisa',
  'detail.poplatek': 'Bayad',
  'detail.tema': 'Paksa',
  'detail.forma.offline': 'Harapan',
  'detail.forma.online': 'Online',
  'detail.forma.hybrid': 'Harapan at online',
  'detail.rozsah.local': 'Lokal',
  'detail.rozsah.national': 'Pambansa',
  'detail.rozsah.international': 'Pandaigdig',
  'detail.rocnik.upcoming': 'Paparating',
  'detail.rocnik.registration_open': 'Bukas ang rehistrasyon',
  'detail.rocnik.registration_closed': 'Sarado ang rehistrasyon',
  'detail.rocnik.completed': 'Tapos na',
  'detail.zdroj': (p) => `Pinagkunan: ${p.zdroj}`,
  'detail.upraveno': (p) => `Huling na-update: ${p.datum}`,
  'detail.overeno': 'Nasuri na tama ito. Hindi ito pag-endorso ng Bloom.',
  'detail.neovereno': 'Hindi pa nabeberipika ang entry na ito. Puwedeng nagbago ang mga detalye — pakitingnan sa pinagkunan.',
  'detail.nenalezen': 'Hindi namin kilala ang entry na iyon. Baka nabura na ito o naghihintay pa ng pagsusuri.',
  'detail.chyba': 'Hindi na-load ang entry.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Ano ang umiiral dito',
  'profil.name_change': 'Pagpapalit ng pangalan',
  'profil.gender_marker': 'Legal na gender marker',
  'profil.surgery_required': 'Kailangang operasyon',
  'profil.healthcare': 'Akses sa pangangalagang pangkalusugan',
  'profil.legal_protection': 'Proteksyon laban sa diskriminasyon',
  'profil.safety': 'Kaligtasan',
  'profil.stav.yes': 'Oo',
  'profil.stav.limited': 'Bahagya',
  'profil.stav.no': 'Hindi',
  'profil.stav.unknown': 'Hindi alam',
  'profil.zdroj': 'Pinagkunan',
  'profil.zdrojZRoku': (p) => `pinagkunan mula ${p.rok}`,
  'profil.overeno': (p) => `Nasuri noong ${p.datum}`,
  'profil.zmena': 'Kamakailang pagbabago',
  'profil.odKdy': (p) => `may bisa mula ${p.datum}`,
  'profil.doklady': 'Mga pinagkunan',
  'profil.zakon': 'batas o korte',
  'profil.upozorneni': 'Hindi ito legal na payo. Nagbabago ang mga batas at marami ang nakadepende sa partikular '
      + 'mong sitwasyon — pakitingnan sa pinagkunan o sa isang organisasyon sa bansang '
      + 'iyon bago ka kumilos batay dito.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Magmungkahi ng ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Dadaan sa pagsusuri ang suhestiyon mo bago ito lumabas sa Bloom. Punan ang '
      + 'alam mo — kami na ang bahala sa iba.',
  'navrh.jednotne.organizations': 'organisasyon',
  'navrh.jednotne.events': 'kaganapan',
  'navrh.jednotne.pageants': 'pageant',
  'navrh.jednotne.resources': 'sanggunian',
  'navrh.popis.organizations': 'Isang samahan, non-profit o support group.',
  'navrh.popis.events': 'Isang pagtitipon, Pride, workshop, kumperensiya.',
  'navrh.popis.pageants': 'Isang trans pageant – petsa, rehistrasyon, nag-oorganisa.',
  'navrh.popis.resources': 'Praktikal na impormasyon – kalusugan, batas, dokumento, kontak.',
  'navrh.nazev': 'Pangalan',
  'navrh.popisPole': 'Paglalarawan',
  'navrh.zeme': 'Bansa',
  'navrh.mesto': 'Lungsod',
  'navrh.adresa': 'Address',
  'navrh.web': 'Website',
  'navrh.email': 'Email',
  'navrh.telefon': 'Telepono',
  'navrh.odkudVis': 'Paano mo ito nalaman',
  'navrh.odkudVisPriklad': 'hal. sa website nila, nandoon ako…',
  'navrh.vyberte': '— pumili —',
  'navrh.forma': 'Paraan',
  'navrh.rozsah': 'Saklaw',
  'navrh.platiPro': 'Umiiral para sa',
  'navrh.platnost.global': 'Buong mundo',
  'navrh.platnost.country': 'Isang bansa',
  'navrh.platnost.region': 'Isang rehiyon',
  'navrh.platnost.city': 'Isang lungsod',
  'navrh.odkazAkce': 'Link ng kaganapan',
  'navrh.odkazPrihlaska': 'Link ng rehistrasyon',
  'navrh.odkazy': 'Mga link',
  'navrh.text': 'Teksto',
  'navrh.odeslat': 'Ipadala ang suhestiyon',
  'navrh.odesilam': 'Ipinapadala…',
  'navrh.chyba': 'Hindi naipadala ang suhestiyon',
  'navrh.dikyTitulek': 'Salamat, natanggap namin',
  'navrh.dikyPopis': 'Natanggap namin ang suhestiyon mo. Susuriin ito ng isa sa amin at pagkatapos ay '
      + 'lalabas ito sa Bloom. Walang inilalathala nang kusa.',
  'navrh.zavrit': 'Isara',
  'navrh.seznamNapoveda': 'Paghiwalayin ang mga bagay gamit ang kuwit.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Sa iyo ba ang ${p.druh} na ito?`,
  'prevzeti.popis': 'Puwede mong kunin ang profile at panatilihing napapanahon ang mga detalye. '
      + 'Dadaan muna sa pagsusuri ang hiling.',
  'prevzeti.tlacitko': 'Angkinin ang profile na ito',
  'prevzeti.spravujes': 'Ikaw ang namamahala sa profile na ito. Puwede mong itama ang mga detalye anumang oras — agad na may bisa ang mga pagbabago.',
  'prevzeti.upravit': 'I-edit ang mga detalye',
  'prevzeti.spravujeSama': (p) => `Ang ${p.druh} mismo ang namamahala sa profile na ito.`,
  'prevzeti.ceka': 'Natanggap namin ang paghiling mo at sinusuri na namin ito.',
  'prevzeti.formulacTitulek': (p) => `Angkinin ang profile — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Bago namin ibigay ang profile, kailangan naming malaman na talagang kabilang ka sa '
      + 'organisasyon. Dadaan sa pagsusuri ang hiling; walang nagbabago agad.',
  'prevzeti.role': 'Ano ang papel mo roon?',
  'prevzeti.rolePriklad': 'hal. coordinator, tagapangulo ng samahan',
  'prevzeti.doklad': 'Paano namin iyon mabeberipika?',
  'prevzeti.dokladPriklad': 'hal. nakalista ako sa website ng organisasyon sa ilalim ng mga kontak; o sumulat mula sa opisyal na address',
  'prevzeti.dokladNapoveda': 'Sapat na ang link sa page kung saan ka nakalista, o ang opisyal na '
      + 'address ng organisasyon na pagsusulatan.',
  'prevzeti.kontakt': 'Ang kontak mo',
  'prevzeti.kontaktPriklad': 'email o telepono',
  'prevzeti.dalsi': 'Iba pang bagay',
  'prevzeti.nepovinne': '(opsyonal)',
  'prevzeti.odeslat': 'Ipadala ang hiling',
  'prevzeti.odesilam': 'Ipinapadala…',
  'prevzeti.vyplnObe': 'Pakisabi ang papel mo at kung paano ito mabeberipika.',
  'prevzeti.prijato': 'Salamat. Natanggap namin ang hiling mo at babalikan ka namin.',
  'prevzeti.chyba': 'Hindi naipadala ang hiling.',
  'prevzeti.upravaTitulek': (p) => `I-edit ang profile — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Sadyang wala rito ang pangalan at lokasyon: sa pamamagitan ng mga iyon hinahanap at '
      + 'inaayos ang mga entry. Kung nagbago ang mga iyon, sumulat sa amin at kami na ang mag-a-update.',
  'prevzeti.popisPole': 'Paglalarawan',
  'prevzeti.email': 'Email',
  'prevzeti.telefon': 'Telepono',
  'prevzeti.web': 'Website',
  'prevzeti.ulozeno': 'Na-save.',
  'prevzeti.ukladam': 'Sine-save…',
  'prevzeti.chybaUlozeni': 'Hindi na-save.',
  'prevzeti.druh.organizations': 'organisasyon',
  'prevzeti.druh.events': 'kaganapan',
  'prevzeti.druh.pageants': 'pageant',
  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'I-edit ang mga detalye at setting mo',
  'profil.overeny': 'Beripikado',
  'profil.neovereny': 'Hindi beripikado',
  'profil.overteEmail': 'Pakikumpirma ang email mo. May limitadong karapatan ang hindi beripikadong account.',
  'profil.emailOdeslan': 'Naipadala ang email ng kumpirmasyon.',
  'profil.emailChyba': 'Hindi naipadala ang email',
  'profil.odeslano': 'Naipadala.',
  'profil.overeniOdbornika': 'Beripikasyon bilang propesyonal o abogado',
  'profil.pracujeteVOboru': 'Nagtatrabaho ka ba sa larangan? Kumuha ng beripikadong badge.',
  'profil.zadostOdeslana': 'Naipadala ang hiling',
  'profil.pozadatOOvereni': 'Humiling ng beripikasyon',
  'profil.zadostTitulek': 'Humiling ng beripikasyon bilang propesyonal o abogado',
  'profil.zadostPopis': 'Punan ang mga detalye ng hiling mo. Susuriin ito ng mga moderator.',
  'profil.pozadovanaRole': 'Hinihiling na papel',
  'profil.roleOdbornik': 'Propesyonal',
  'profil.rolePravnik': 'Abogado',
  'profil.specializace': 'Espesyalisasyon',
  'profil.odkazNaProfil': 'Link sa propesyonal na profile',
  'profil.zpravaProAdmina': 'Maikling mensahe para sa admin',
  'profil.odesilam': 'Ipinapadala…',
  'profil.odeslatZadost': 'Ipadala ang hiling ng beripikasyon',
  'profil.vyplnteSpecializaci': 'Pakipunan ang espesyalisasyon mo',
  'profil.zadostUspech': 'Naipadala na ang hiling mo ng beripikasyon.',
  'profil.zadostChyba': 'Hindi naipadala ang hiling',

  // bezpečnost
  'bezp.titulek': 'Seguridad',
  'bezp.sifrovaniZapnuto': (p) => `Nakabukas ang encryption ng mensahe${p.odemceno ? ' at nakabukas ang susi' : ' (naka-lock sa tab na ito)'}.`,
  'bezp.sifrovaniVypnuto': 'Hindi mo pa nabubuksan ang encryption ng mensahe.',
  'bezp.sifrovaniKde': 'Bubuksan mo ito at ila-unlock sa page ng Mga mensahe.',
  'bezp.sifrovaniKdeVypnute': 'Puwede mo itong buksan mula sa page ng Mga mensahe, sa kahit anong usapan.',
  'bezp.zmenaHesla': 'Palitan ang password',
  'bezp.zmenaHeslaSifrovani': 'Nakabukas ang encryption mo, kaya ang pagpapalit ng password ay muling bumabalot din sa susi ng mga mensahe mo. '
      + 'Kaya kailangan ang kasalukuyang password — kung wala ito, hindi mabubuksan ang susi at mawawala ang mga mensahe mo.',
  'bezp.stavajiciHeslo': 'Kasalukuyang password',
  'bezp.noveHeslo': 'Bagong password',
  'bezp.noveHesloZnovu': 'Ulitin ang bagong password',
  'bezp.pozadavky': 'Hindi bababa sa 8 karakter, malaki at maliit na titik, isang numero at isang espesyal na karakter.',
  'bezp.zmenitHeslo': 'Palitan ang password',
  'bezp.menim': 'Pinapalitan…',
  'bezp.hesloNeshoda': 'Hindi magkatugma ang mga bagong password.',
  'bezp.vyplnObe': 'Pakipunan ang dalawang password.',
  'bezp.stareNesedi': 'Mali ang kasalukuyang password — mawawala ang susi ng mga mensahe mo, kaya walang binago.',
  'bezp.zmenenoSKlicem': 'Napalitan ang password. Muling binalot ang susi ng mga mensahe mo, kaya nananatiling nababasa ang mga lumang mensahe.',
  'bezp.zmeneno': 'Napalitan ang password.',
  'bezp.zmenaChyba': 'Hindi napalitan ang password.',
  'bezp.nepamatujes': 'Hindi mo maalala ang password ng susi?',
  'bezp.zahoditPopis': 'Puwede mong itapon ang susi at magsimula ulit. Tuluyan nang mawawala ang mga mensaheng na-encrypt hanggang ngayon '
      + '— walang makakabasa ng mga iyon, kahit kami. Kaya nga ito ligtas.',
  'bezp.zahodit': 'Itapon ang mga susi at magsimula ulit',
  'bezp.zahoditPotvrzeni': 'Talagang itatapon ang mga susi?\n\nTuluyan nang mawawala ang bawat mensaheng na-encrypt hanggang ngayon '
      + '— walang makakabasa ng mga iyon, kahit kami. Gawin lang ito kung hindi mo maalala ang password '
      + 'na ginamit mo noong binuksan mo ang encryption.',
  'bezp.klicSmazan': 'Nabura ang mga susi. Paki-reload ang page.',
  'bezp.nepovedlo': 'Hindi natuloy iyon.',
  'bezp.prohlizecNeumi': 'Hindi sinusuportahan ng browser na ito ang encryption na ginagamit ng Bloom.',

  'profil.mujProfil': 'Profile ko',
  'profil.specializacePriklad': 'hal. psychologist, sexologist, abogado…',
  'profil.zpravaPriklad': 'Halimbawa, link sa propesyonal mong rehistrasyon o sa website ng praktis mo…',
  'profil.overeniUvod': 'Gusto mo bang maging beripikadong propesyonal o abogado sa Bloom? Magpadala ng hiling ng beripikasyon. '
      + 'Kailangang tumugma ang profile mo sa totoo mong propesyon.',

  'profil.oborPriklad': 'hal. plastic surgery, batas ng pamilya…',
  'profil.nepovinnyText': 'Opsyonal na karagdagang tala…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Dalawang hakbang na pag-sign in',
  'dvf.zapnuto': (p) => `Nakabukas. May ${p.pocet} ka pang natitirang backup code.`,
  'dvf.vypnuto': 'Bukod sa password mo, maglalagay ka rin ng anim na numerong code mula sa app sa telepono mo.',
  'dvf.chraniA': 'Pinoprotektahan nito ang',
  'dvf.chraniPrihlaseni': 'pag-sign in',
  'dvf.chraniB': ': ang taong alam ang password mo pero walang telepono mo ay hindi makakapasok.',
  'dvf.nechrani': 'Hindi nito pinoprotektahan ang mga naka-encrypt na mensahe',
  'dvf.nechraniPopis': ' — binubuksan ang mga iyon ng password mo sa sarili mong browser at walang kinalaman ang server.',
  'dvf.ulozKody': 'I-save ang sampung backup code na ito',
  'dvf.ulozKodyPopis1': 'Isang beses lang gumagana ang bawat isa, at ito lang ang daan pabalik kung mawala ang telepono mo.',
  'dvf.znovuNeukaze': 'Walang magpapakita ng mga ito sa iyo ulit',
  'dvf.ulozKodyPopis2': ' — hash lang ng mga ito ang iniimbak namin.',
  'dvf.zkopirovat': 'Kopyahin',
  'dvf.ulozilaJsem': 'Na-save ko na',
  'dvf.zkopirovano': 'Nakopya.',
  'dvf.kopieChyba': 'Hindi nakopya, pakisulat na lang sa kamay.',
  'dvf.zapnout': 'Buksan ang dalawang hakbang na pag-sign in',
  'dvf.pripravuji': 'Inihahanda…',
  'dvf.nactiKod': 'I-scan ang code na ito sa authenticator app — halimbawa Google Authenticator, Authy, 1Password o Aegis.',
  'dvf.qrNejde': 'Hindi ma-scan ang QR code?',
  'dvf.zadejRucne': 'Ilagay ang susi na ito sa app nang manu-mano:',
  'dvf.opisKod': 'Ilagay ang code na nasa app',
  'dvf.zapnoutKratce': 'Buksan',
  'dvf.overuji': 'Tinitingnan…',
  'dvf.noveKody': 'Mga bagong backup code',
  'dvf.vypnout': 'Isara',
  'dvf.noveKodyPopis': 'Papalitan ng bagong set ang luma — hihinto sa paggana ang kasalukuyan mong mga backup code.',
  'dvf.kodZAplikace': 'Code mula sa app',
  'dvf.vygenerovat': 'Gumawa',
  'dvf.vypnutiPopis': 'Ang pagsasara nito ay nangangailangan ng password mo at ng balidong code. Parehong sinadya: kung hindi, kayang alisin ito ng sinumang makahawak ng bukas na browser.',
  'dvf.kodNeboZalozni': 'Code mula sa app o backup code',
  'dvf.vypinam': 'Isinasara…',
  'dvf.vypnoutCele': 'Isara ang dalawang hakbang na pag-sign in',
  'dvf.vypnuto2': 'Nakasara na ang dalawang hakbang na pag-sign in.',
  'dvf.kodNesedi': 'Mali ang code na iyon.',
  'dvf.nepovedlo': 'Hindi natuloy iyon.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Na-update ang profile.',
  'pf.chyba': 'Hindi na-update ang profile',
  'pf.fotkaNahrana': 'Na-upload ang larawan.',
  'pf.fotkaChyba': 'Hindi na-upload ang larawan',
  'pf.fotkaVelka': 'Masyadong malaki ang larawan (max 5 MB)',
  'pf.oznameniUlozeno': 'Na-save ang mga setting ng notipikasyon.',
  'pf.oznameniChyba': 'Hindi na-save ang mga setting',
  'pf.zruseno': 'Nabura na ang profile mo',
  'pf.zruseniChyba': 'Hindi nabura ang profile',
  'pf.zruseniPotvrzeni': 'Talagang buburahin mo ang profile mo? Hindi na ito maibabalik at mabubura ang lahat ng data mo.',
  'pf.urlFacebook': 'Kailangang magsimula sa https:// ang Facebook URL',
  'pf.urlInstagram': 'Kailangang magsimula sa https:// ang Instagram URL',
  'pf.urlLinkedin': 'Kailangang magsimula sa https:// ang LinkedIn URL',
  'pf.ukladam': 'Sine-save…',
  'pf.ulozitOznameni': 'I-save ang mga setting ng notipikasyon',
  'pf.oznameniZpravy': 'Mga pribadong mensahe',
  'pf.oznameniAdmin': 'Bagong mensahe mula sa administrator',
  'pf.oznameniUzivatel': 'Bagong mensahe mula sa ibang miyembro',
  'pf.oznameniPodpora': 'Bagong post sa Tulungan ang isa\'t isa',
  'pf.oznameniNabidky': 'Mga alok at hinahanap',

  // odznaky
  'pf.odznakAdmin': 'Administrator',
  'pf.odznakPravnik': 'Abogado',
  'pf.odznakSpecialista': 'Beripikadong propesyonal',
  'pf.odznakClen': 'Beripikadong miyembro ng komunidad',
  'pf.odznakPomocnik': 'Aktibong katulong',
  'pf.odznakDuveryhodny': 'Pinagkakatiwalaang miyembro',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Naidagdag ang larawan sa gallery.',
  'gal.smazano': 'Nabura ang larawan',
  'gal.hesloKratke': 'Kailangang hindi bababa sa 4 na karakter ang password ng gallery',
  'gal.nahraniChyba': 'Hindi na-upload ang larawan',
  'gal.mazaniChyba': 'Hindi nabura ang larawan',
  'gal.souborVelky': 'Masyadong malaki ang file (max 5 MB)',
  'gal.ulozitNastaveni': 'I-save ang mga setting',
  'gal.soukromiGalerie': 'Privacy ng gallery',
  'gal.verejnaGalerie': 'Pampublikong gallery',
  'gal.hesloPopis': 'Kailangang ilagay ng mga bisita ang password na ito para makita ang gallery.',
  'gal.pridat': 'Magdagdag ng larawan o video',
  'gal.prazdna': 'Wala pang larawan sa gallery',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Nasaan ako ngayon?',
  'cesta.popis': 'Ibahagi ang yugto ng transition mo kung gusto mo – o itago mo ito para sa sarili mo.',
  'cesta.soukroma': 'Pribado ang yugto mo',
  'cesta.viditelna': 'Nakikita ng iba ang yugto mo',
  'cesta.jenTy': 'Ikaw lang ang nakakakita ng yugto mo',
  'cesta.mohouNajit': 'Mahahanap ka ng iba sa pamamagitan ng “Maghanap ng taong nasa katulad na yugto”',
  'cesta.poznamka': 'Personal na tala',
  'cesta.volitelna': '(opsyonal)',
  'cesta.poznamkaPriklad': 'Kahit anong gusto mong ibahagi o tandaan…',
  'cesta.najitPodobne': 'Maghanap ng taong nasa katulad na yugto',
  'cesta.hledam': 'Naghahanap…',
  'cesta.ulozit': 'I-save ang paglalakbay ko',
  'cesta.ulozeno': 'Na-save ang paglalakbay mo.',
  'cesta.vyberteFazi': 'Pumili ng isang yugto',
  'cesta.chyba': 'Hindi na-save',

  'pf.socialniSite': 'Social media',
  'pf.avatarFoto': 'Avatar / larawan sa profile',
  'pf.nahratProfilni': 'Mag-upload ng larawan sa profile',
  'pf.zrusitProfil': 'Burahin ang profile',
  'pf.nastaveniOznameni': 'Mga setting ng notipikasyon',
  'pf.nastaveniOznameniPopis': 'Piliin kung aling mga bagay ang gusto mong pagpadalhan ng notipikasyon.',
  'gal.overEmail': 'Para makapag-upload ng larawan, kumpirmahin muna ang email mo.',
  'cesta.coMeCeka': 'Ano ang naghihintay',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Mga mensahe',
  'zpr.hledatUzivatele': 'Maghanap ng miyembro…',
  'zpr.zadneKonverzace': 'Wala pang usapan',
  'zpr.vyhledejteVyse': 'Maghanap ng miyembro sa itaas',
  'zpr.vyberteKonverzaci': 'Pumili ng usapan o maghanap ng miyembro',
  'zpr.napisteZpravu': 'Sumulat ng mensahe…',
  'zpr.nahravam': 'Nagre-record…',
  'zpr.prilozitObrazek': 'Maglakip ng larawan',
  'zpr.hlasovaZprava': 'Mensaheng boses',
  'zpr.zastavitNahravani': 'Itigil ang pagre-record',
  'zpr.obrazek': 'Larawan',
  'zpr.overteEmail': 'Para makapagpadala ng mensahe, kumpirmahin ang email mo.',
  'zpr.profil': 'Profile',

  // šifrování
  'zpr.sifrovanaZprava': 'Naka-encrypt na mensahe',
  'zpr.odemkniNahore': 'Naka-encrypt na mensahe — i-unlock ang mga mensahe mo sa itaas.',
  'zpr.nelzeOtevrit': 'Hindi nabuksan ang naka-encrypt na mensaheng ito.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Hindi nahanap ang miyembro',
  'zpr.prijemceNenalezen': 'Hindi nahanap ang tatanggap',
  'zpr.prihlasteZnovu': 'Paki-sign in ulit (natapos na ang session mo)',
  'zpr.serverNedostupny': 'Hindi maabot ang server. Tingnan kung tumatakbo ang backend.',
  'zpr.chybaOdeslani': 'Hindi naipadala',
  'zpr.souborVelky': 'Masyadong malaki ang file (max 5 MB)',
  'zpr.formatNepodporovan': 'Hindi suportadong uri ng file',
  'zpr.mediaOdeslano': 'Naipadala ang media',
  'zpr.mikrofon': 'Hindi available ang mikropono',
  'zpr.hlasovkaOdeslana': 'Naipadala ang mensaheng boses',
  'zpr.hlasovkaChyba': (p) => `Hindi naipadala ang mensaheng boses: ${p.detail}`,
  'zpr.smazano': 'Nabura ang usapan',
  'zpr.smazaniChyba': 'Hindi nabura ang usapan',
  'zpr.smazaniPotvrzeni': 'Mawawala ito sa listahan mo, pati na ang mga attachment. Mananatili ang kopya ng kausap mo — '
      + 'tuluyang nabubura sa server ang mensahe kapag pareho ninyong binura ito.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Pakilagay ang password mo.',
  'sif.zapnuto': 'Nakabukas ang encryption.',
  'sif.odemceno': 'Naka-unlock na ang mga mensahe mo.',
  'sif.hesloNesedi': 'Mali ang password na iyon.',
  'sif.prohlizecNeumi': 'Hindi sinusuportahan ng browser na ito ang encryption na ginagamit ng Bloom. Puwede ka pa ring sumulat, '
      + 'pero hindi magiging end-to-end encrypted ang mga mensahe.',
  'sif.noveJsouSifrovane': 'Naka-encrypt na ang mga bagong mensahe. Ikaw lang ang may susi — hindi ito mabasa ng server.',
  'sif.odemkniZpravy': 'I-unlock ang mga mensahe mo',
  'sif.odemkniPopis': 'Nasa memorya lang ng tab na ito ang susi, kaya pagkatapos mag-reload ang page kailangan ulit ang password. '
      + 'Hindi namin ito puwedeng itago kahit saan — kung kaya, hindi na ito magiging encryption na ikaw lang ang may kontrol.',
  'sif.zapniSifrovani': 'Buksan ang encryption ng mensahe',
  'sif.zapniPopis': 'Ang mga bagong mensahe ay ine-encrypt dito mismo sa device mo. Basura lang ang natatanggap ng server '
      + 'at hindi niya mababasa ang mga ito — kahit hilingin pa ng korte.',
  'sif.pozorA': 'Mag-ingat: binubuksan ng password mo ang susi.',
  'sif.pozorTucne': 'Kapag nakalimutan mo ito, walang makakabasa ng mga naka-encrypt mong mensahe',
  'sif.pozorB': ' — kahit kami. Iyon mismo ang punto, pero ibig sabihin, kailangan mo ng lugar na pagtataguan nito.',
  'sif.mobilA': 'Ang pagbukas nito ay nagpapalit din ng paraan ng pag-sign in mo: hindi na talaga umaabot sa server ang password mo, hash lang nito ang ipinapadala.',
  'sif.mobilTucne': 'Hindi na makakapag-sign in sa account na ito ang mas lumang Bloom mobile app',
  'sif.mobilB': ' hangga\'t hindi namin ito na-update. Sa web ay patuloy na gumagana ang lahat.',
  'sif.zapnoutSifrovani': 'Buksan ang encryption',
  'sif.odemknout': 'I-unlock',
  'sif.tvojeHeslo': 'Ang Bloom password mo',
  'sif.prilohaZamcena': 'Naka-encrypt na attachment — i-unlock ang mga mensahe mo sa itaas.',
  'sif.prilohaChyba': 'Hindi nabuksan ang attachment.',
  'sif.priloha': 'Attachment ng mensahe',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Ang lokasyon mo',
  'okoli.nastavtePolohu': 'Itakda ang lokasyon mo para bagay sa iyo ang mga resulta',
  'okoli.vyberteVyse': 'Pumili ng lokasyon sa itaas para makita ang mga alok at propesyonal malapit sa iyo',
  'okoli.zadniOdbornici': 'Wala pang propesyonal na nakarehistro sa lugar na ito',
  'okoli.zadneNabidky': 'Wala pang alok sa lugar na ito',
  'okoli.zadniClenove': 'Wala pang miyembro ng komunidad sa lugar na ito',
  'okoli.vytvoritNabidku': 'Gumawa ng alok',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Naghahanap:',
  'hled.vysledkyPro': 'Mga resulta para sa:',
  'hled.nicPro': 'Wala kaming nakita para sa:',
  'hled.nicZkuste': 'Wala kaming nakita. Subukan ang ibang salita.',
  'hled.zkratte': 'Subukan ang mas maikling parirala o ibang keyword.',
  'hled.zadejte': 'I-type ang hinahanap mo at pindutin ang Enter',
  'hled.priklady': 'Halimbawa: FFS, hormone, pangalan, doktor, dokumento, operasyon…',
  'hled.uzivatele': 'Mga miyembro',
  'hled.odbornici': 'Mga propesyonal na trans-friendly',
  'hled.clanky': 'Legal na tulong – mga artikulo',
  'hled.otazky': 'Mga tanong ng komunidad',
  'hled.nabidky': 'Mga alok ng tulong',
  'hled.prispevky': 'Mga post',
  'hled.recenze': 'Mga review ng propesyonal',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Hindi nahanap ang miyembro',
  'up.oMne': 'Tungkol sa',
  'up.clenOd': 'Miyembro mula pa noong',
  'up.odznakSpravce': 'Administrator',
  'up.odznakPravnik': 'Abogado',
  'up.odznakOdbornik': 'Beripikadong propesyonal',
  'up.odznakPravnikOvereny': 'Beripikadong abogado',
  'up.odznakClen': 'Beripikadong miyembro',
  'up.odznakPomocnik': 'Aktibong katulong',
  'up.odznakDuveryhodny': 'Pinagkakatiwalaan',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Balik sa Bloom',
  'kom.oProjektu': 'Ginawa ang Bloom bilang ligtas na espasyong pangkomunidad para sa mga trans na tao sa Czechia – isang lugar '
      + 'para magbahagi ng karanasan, humanap ng suporta, makaugnay ng mga propesyonal at makakilala ng iba. '
      + 'Pinapatakbo ng komunidad ang proyekto nang boluntaryo. Layunin nito ang diskresyon, privacy at pagtutulungan.',
  'kom.kontaktText': 'May tanong, o kailangan ng tulong? Makipag-ugnayan sa amin. Sinisikap naming sumagot sa lalong madaling panahon.',
  'kom.respekt': 'Nirerespeto namin ang isa\'t isa',
  'kom.respektPopis': 'Tinatawag namin ang bawat isa sa pangalan at panghalip na ginagamit nila. Nirerespeto namin ang iba\'t ibang landas at karanasan '
      + '– walang tama o maling paraan ng pagiging trans.',
  'kom.soukromi': 'Pinoprotektahan namin ang privacy ng isa\'t isa',
  'kom.soukromiPopis': 'Ang ibinahagi sa Bloom ay nananatili sa Bloom. Huwag magbahagi ng impormasyon tungkol sa ibang miyembro nang '
      + 'walang pahintulot nila. Nirerespeto namin ang pagiging anonymous.',
  'kom.pomahame': 'Tinutulungan namin ang isa\'t isa',
  'kom.pomahamePopis': 'Ang Bloom ay tungkol sa magkabilaang suporta. Nagbabahagi kami ng karanasan, tumutulong sa isa\'t isa at gumagawa ng ligtas na espasyo '
      + 'para sa sinumang naghahanap ng koneksyon o impormasyon.',
  'kom.obtezovani': 'Hindi kami pumapayag sa panliligalig',
  'kom.obtezovaniPopis': 'Walang lugar sa Bloom ang panliligalig, pambubully o mapanuyang komento. Kung hindi ka komportable, '
      + 'sumulat sa isang administrator.',
  'kom.spam': 'Walang spam at patalastas',
  'kom.spamPopis': 'Hindi palengke ang Bloom. Huwag magpaskil ng hindi hinihinging patalastas o komersyal na nilalaman. '
      + 'Ang mga alok at hinahanap ay nasa Tulungan ang isa\'t isa.',
  'kom.prostor': 'Espasyo para sa bawat yugto',
  'kom.prostorPopis': 'Hindi ka nag-iisa, nasaan ka man sa paglalakbay mo. Tinatanggap namin ang mga taong nag-iisip pa lang ng '
      + 'transition, nasa gitna nito, at nakalampas na – at tinatanggap namin ang bawat landas kung ano ito.',
  'kom.dataPopis': 'Ang Bloom ay nangongolekta lang ng data na kailangan ng plataporma para gumana: ang email mo, palayaw at ang profile '
      + 'na ikaw mismo ang gumawa.',
  'kom.dataTretiStrany': 'Hindi ibinabahagi sa ibang partido ang data mo. Walang ginagamit na teknolohiya ng pagsubaybay o ad network ang plataporma.',
  'kom.dataSmazani': 'May karapatan kang hilingin na burahin ang account mo at lahat ng data na nakakabit dito. Sumulat sa isang administrator.',

  'okoli.podtitulek': 'Maghanap ng miyembro ng komunidad, serbisyo at propesyonal malapit sa iyo',
  'okoli.cleneVOkoli': (p) => `Mga miyembro ng komunidad malapit sa ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Mga alok ng tulong malapit sa ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Mga propesyonal malapit sa ${p.misto}`,
  'hled.zobrazitVice': 'Ipakita pa',
  'kom.titulek': 'Mga alituntunin ng komunidad',
  'kom.podtitulek': 'Ligtas na espasyo para sa lahat',
  'kom.jakNahlasit': 'Paano mag-ulat ng problema',
  'kom.jakNahlasitPopis': 'Kung may makita kang hindi angkop na pag-uugali, may dalawang paraan: ang button na “I-ulat ang miyembro” '
      + 'sa profile nila, o sumulat sa isang administrator.',
  'kom.duverne': 'Kumpidensyal ang ulat mo.',
  'kom.ochranaSoukromi': 'Privacy',
  'obecne.zpetKratce': 'Bumalik',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Wala pang ibang tao sa komunidad na pampublikong nagbabahagi ng yugtong ito.',
  'cesta.poznamkaFazePriklad': 'Kahit anong gusto mong ibahagi o tandaan tungkol sa yugtong ito…',
  'pruvodce.fazeNenalezena': 'Hindi nahanap ang yugto',
  'pruvodce.pripravujeme': 'Inihahanda pa namin ang bahaging ito.',
  'pruvodce.krokyJenTy': 'Ikaw lang ang nakakakita ng mga hakbang na tinsek mo.',
  'pruvodce.nastavitFazi': 'Itakda bilang kasalukuyan kong yugto',
  'pruvodce.fazeNastavena': 'Naitakda bilang kasalukuyan mong yugto',
  'pruvodce.chyba': 'Hindi na-save, pakisubukan ulit',
  'pruvodce.kroku': 'hakbang',
  'pruvodce.odborniku': () => 'propesyonal para sa yugtong ito',
  'pruvodce.pribehu': () => 'kuwento mula sa mga taong nasa yugtong ito',

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Pag-reset ng password',
  'reset.popis': 'Maglagay ng bagong password para sa Bloom account mo.',
  'reset.noveHeslo': 'Bagong password',
  'reset.noveHesloPriklad': 'Maglagay ng bagong password',
  'reset.potvrdit': 'Kumpirmahin ang bagong password',
  'reset.nastavit': 'Itakda ang bagong password',
  'reset.ukladam': 'Sine-save…',
  'reset.hotovo': 'Napalitan na ang password mo. Puwede ka nang mag-sign in.',
  'reset.neplatnyOdkaz': 'Hindi balido ang link ng pag-reset ng password na iyon.',
  'reset.odkazVyprsel': 'Nag-expire na o hindi balido ang link ng pag-reset. Humiling ng bago.',
  'reset.chyba': 'Hindi na-reset ang password.',
  'reset.neshoda': 'Hindi magkatugma ang mga password.',
  'reset.ztratiPristup': 'mawawalan ng akses',

  'cesta.volitelne': 'Ganap itong opsyonal. Ibahagi ang yugto ng transition mo kung gusto mo – o itago mo ito para sa sarili mo. '
      + 'Puwede ka ring maghanap ng taong nasa katulad na punto ng paglalakbay.',
  'cesta.hledatVeFazi': 'Maghanap ng taong nasa yugtong ito:',
  'cesta.jenVerejne': '(mga miyembro lang na pampublikong nagbabahagi)',
  'pruvodce.zpetNaCestu': 'Balik sa Ang paglalakbay ko',
  'pruvodce.tadyJsi': 'Nandito ka ngayon',
  'reset.prejitNaPrihlaseni': 'Pumunta sa pag-sign in',
  'reset.sifrovaniVarovani': 'Kung nakabukas ang encryption ng mensahe mo: ang pag-reset ng password ay nangangahulugang hindi mo na maaabot ang mga luma '
      + 'mong naka-encrypt na mensahe. Ang susi nito ay binubuksan ng orihinal na password, at walang nakakaalam nito rito, kaya hindi '
      + 'ito puwedeng balutin ulit. Puwede pa ring i-encrypt ang mga bagong mensahe; hindi na mababasa ang mga luma — kahit namin.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Mag-sign in',
  'uvod.vytvoritUcet': 'Gumawa ng account',
  'uvod.uzMamUcet': 'May account na ako',
  'uvod.nadpis': 'Ligtas na espasyo para sa trans community',
  'uvod.podnadpis': 'Ang Bloom ay pribadong lugar kung saan puwede kang magsalita nang tapat, humanap ng mga propesyonal na trans-friendly '
      + 'at dumaan sa transition kasama ng mga taong alam ang pakiramdam.',
  'uvod.zdarma': 'Libre ang pag-sign up. Bumubukas lang ang nilalaman ng Bloom pagkatapos mong mag-sign in.',
  'uvod.kCemuJe': 'Para saan ang Bloom',
  'uvod.kCemuJe1': 'Ang paghahanap ng impormasyon tungkol sa transition sa Czechia ay karaniwang nangangahulugan ng pag-click sa magkakalat na '
      + 'forum, lumang artikulo at link na hindi mo alam kung mapagkakatiwalaan. At maraming tanong ang '
      + 'pinakamainam na sagutin ng taong dumaan na rito.',
  'uvod.kCemuJe2': 'Pinagsasama-sama ng Bloom ang lahat sa isang lugar: mga propesyonal na maganda ang karanasan ng komunidad, isang gabay '
      + 'sa mga yugto ng transition, legal na tulong, at higit sa lahat mga taong puwede mong sulatan.',
  'uvod.kCemuJe3': 'At dahil ito ang mga bagay na ayaw sabihin ninuman sa buong internet, ginawa ang Bloom mula '
      + 'sa simula upang wala talagang makita mula sa labas.',
  'uvod.coNajdes': 'Ano ang makikita mo sa Bloom',
  'uvod.coNajdesPopis': 'Walong bahagi na magkakaugnay — mula sa praktikal na tulong hanggang sa ibinahaging karanasan.',
  'uvod.soukromiZaklad': 'Hindi dagdag ang privacy, ito ang pundasyon',
  'uvod.jakZabezpeceny': 'Paano pinoprotektahan ang Bloom',
  'uvod.zabezpeceniPopis': 'Hindi kailanman ipinagbibili o sinusuri ang data ng mga miyembro. Walang pagsubaybay para sa patalastas o analytics ang Bloom '
      + '— walang third-party script ang nakakaalam ng kahit ano tungkol sa iyo.',
  'uvod.coNeumi': 'Ang hindi kaya ng Bloom',
  'uvod.metadataTucne': 'sino ang sumulat kanino at kailan',
  'uvod.coNeumiA': 'Laging alam ng server ang',
  'uvod.coNeumiB': ' — kung wala iyon, hindi nito maihahatid ang mensahe. Hindi itinatago ng end-to-end encryption ang '
      + 'metadata na ito, at hindi rin ito kayang itago ng Signal. Hindi puwedeng i-encrypt ang mga profile, dahil kailangang ipakita ng server '
      + 'ang mga ito sa iba. At dahil web app ang Bloom, kinukuha nito ang encryption code sa server namin '
      + 'sa tuwing bubuksan mo ito — ang sinumang makakuha ng server ay puwedeng, sa teorya, maghatid ng binagong bersyon. '
      + 'Signed app lang mula sa isang store ang nagpoprotekta laban doon.',
  'uvod.pridejSe': 'Sumali sa amin',
  'uvod.pridejSePopis': 'Sapat na ang palayaw at email — hindi mo kailangang ibigay kailanman ang legal mong pangalan. Ang isinusulat mo '
      + 'tungkol sa sarili mo ay nasa iyo, at puwede mo itong baguhin o burahin anumang oras.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Mag-alok ng tulong o humingi nito — mula sa pagsama sa appointment, sa pagpapahiram ng damit, hanggang sa '
      + '“kailangan kong may makausap”.',
  'uvod.karta.odbornici': 'Mga sexologist, endocrinologist, siruhano, psychotherapist at tagagupit. May mapa, kontak at karanasan ng iba.',
  'uvod.karta.pravo': 'Pagpapalit ng pangalan, opisyal na dokumento, trabaho, paaralan. Sinasagot ng mga taong may alam sa larangan.',
  'uvod.karta.pruvodce': 'Ano ang kasama sa bawat hakbang — mula sa unang tanong hanggang sa operasyon. May link sa beripikadong pinagkunan at propesyonal.',
  'uvod.karta.zpravy': 'Sumulat sa kahit sino sa komunidad. Naka-encrypt na nakaimbak sa server ang mga mensahe at attachment.',
  'uvod.karta.zkusenosti': 'Totoong kuwento mula sa mga taong dumaan na rito. Walang censor at walang pagpapaganda.',
  'uvod.karta.aktuality': 'Ano ang nangyayari sa mga usaping trans sa Czechia — pagbabago sa batas, kaganapan, balita ng komunidad.',
  'uvod.karta.okoli': 'Sino ang malapit sa iyo. Para malaman mong hindi ka nag-iisa, kahit sa maliit na bayan.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Wala talagang makikita mula sa labas',
  'uvod.bezp.zvencinicText': 'Ang mga profile, kuwento, larawan, alok at larawan sa mga post ay pawang nangangailangan ng pag-sign in. Kung walang account, walang '
      + 'ibinibigay na impormasyon ang server tungkol sa mga miyembro — kahit sa mga search engine.',
  'uvod.bezp.hesla': 'Walang nakakaalam ng password mo',
  'uvod.bezp.heslaText': 'Bcrypt hash lang ang iniimbak, at hindi mula rito makukuwenta ang orihinal na password. Kahit ang '
      + 'administrator ay hindi nakakakita ng password mo at hindi ito maipapadala sa iyo — puwede ka lang niyang payagang magtakda ng bago.',
  'uvod.bezp.sifrovani': 'Mga mensaheng naka-encrypt mula sa iyo papunta sa kanya',
  'uvod.bezp.sifrovaniText': 'Kapag binuksan mo ang end-to-end encryption, ine-encrypt ang teksto at mga attachment sa sarili mong browser. '
      + 'Ang susi ay binubuksan ng password mo at hindi umaalis sa device mo — basura lang ang natatanggap '
      + 'ng server at hindi niya ito mabasa, kahit hilingin pa ng korte. Kung walang encryption, ang mga mensahe ay naka-encrypt man lang '
      + 'sa disk ng server.',
  'uvod.bezp.kontakty': 'Sa iyo pa rin ang mga kontak mo',
  'uvod.bezp.kontaktyText': 'Hindi kailanman ibinibigay sa ibang miyembro ang email at telepono mo. Pribado ang yugto ng transition mo hangga\'t '
      + 'hindi mo ito mismo inilalathala — at ang mga hakbang na tinsek mo sa Gabay ay nakikita mo lang.',
  'uvod.bezp.smazane': 'Ang nabura ay talagang nabura',
  'uvod.bezp.smazaneText': 'Puwede mong burahin ang usapan anumang oras. Kapag binura ito ng magkabilang panig, tuluyan itong nawawala sa server, '
      + 'pati na ang mga attachment.',
  'uvod.bezp.server': 'Sariling server sa Europa',
  'uvod.bezp.serverText': 'Tumatakbo ang Bloom sa sariling server sa European Union, sa HTTPS lang. Hindi maabot ang database '
      + 'mula sa internet. Naka-encrypt na umaalis ang mga backup papunta sa hiwalay na imbakan at nasubukan na ang pagbabalik ng mga iyon.',

  'uvod.karta.pruvodceNazev': 'Gabay sa transition',
  'uvod.karta.zpravyNazev': 'Mga pribadong mensahe',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Ialok ang kaya mo at kumuha ng tulong sa ibang miyembro ng komunidad',
  'pod.vse': 'Lahat',
  'pod.nabidky': 'Mga alok',
  'pod.poptavky': 'Mga hinahanap',
  'pod.nabidka': 'Alok',
  'pod.poptavka': 'Hinahanap',
  'pod.celaCR': 'Buong Czechia',
  'pod.celySvet': 'Buong mundo',
  'pod.cesko': 'Czechia',
  'pod.svet': 'Mundo',
  'pod.vsechnyTypy': 'Lahat ng kategorya',
  'pod.moje': (p) => `Akin (${p.pocet})`,
  'pod.pridat': 'Magdagdag',
  'pod.overEmail': 'Kumpirmahin ang email mo para makapagdagdag ng alok',
  'pod.novaPoptavka': 'Bagong hinahanap',
  'pod.novaNabidka': 'Bagong alok',
  'pod.popisPoptavky': 'Isulat ang hinahanap mo at ang ibibigay mo kapalit.',
  'pod.popisNabidky': 'Ialok ang kaya mo sa ibang miyembro ng komunidad.',
  'pod.typPrispevku': 'Uri ng post',
  'pod.volitelne': '(opsyonal)',
  'pod.coNabizim': 'Ang inaalok ko',
  'pod.coNabizimP': 'Ang inaalok ko *',
  'pod.coHledamP': 'Ang hinahanap ko *',
  'pod.coHledamVymenou': 'Ang gusto ko kapalit',
  'pod.priklOffer': 'hal. pagluluto, gupit, pagsasalin…',
  'pod.priklNeed': 'hal. masahe, potograpiya…',
  'pod.poptavkaSeZobrazi': 'Lalabas ang hinahanap mo sa tab na Mga hinahanap.',
  'pod.nabidkaSeZobrazi': 'Kung pupunan mo ito, lalabas din ang alok mo sa tab na Mga hinahanap.',
  'pod.popis': 'Paglalarawan',
  'pod.popisPriklad': 'Mas detalyadong paglalarawan…',
  'pod.oblast': 'Lugar',
  'pod.lokalita': 'Lokasyon',
  'pod.nechciUvadet': 'Ayaw kong sabihin',
  'pod.kategorie': 'Kategorya',
  'pod.ostatni': 'Iba pa',
  'pod.pridatPoptavku': 'Magdagdag ng hinahanap',
  'pod.pridatNabidku': 'Magdagdag ng alok',
  'pod.odpovedetNaPrispevek': 'Sumagot sa post',
  'pod.napisteAutorovi': 'Magpadala ng pribadong mensahe sa may-akda.',
  'pod.od': (p) => `Mula kay: ${p.kdo}`,
  'pod.odeslatZpravu': 'Ipadala ang mensahe',
  'pod.konceptOdpovedi': (p) => `Kumusta! Interesado ako sa ${p.co} mong “${p.nazev}”. `,
  'pod.konceptPoptavka': 'hinahanap',
  'pod.konceptNabidka': 'alok',
  'pod.zadneMoje': 'Wala ka pang post',
  'pod.zadneNalezeny': 'Walang nahanap na post',
  'pod.vytvortePrvni': 'Gumawa ng unang alok o hinahanap mo',
  'pod.zkusteFiltry': 'Subukang baguhin ang mga filter o magdagdag ng bagong post',
  'pod.expirovano': 'Wala nang bisa',
  'pod.hledam': 'Hinahanap ko',
  'pod.hledamCo': (p) => `Hinahanap ko: ${p.co}`,
  'pod.nabizimCo': (p) => `Inaalok ko: ${p.co}`,
  'pod.expirovala': 'Wala nang bisa ang alok na ito. Sumulat sa isang administrator para i-renew ito.',
  'pod.odpovedet': 'Sumagot',
  'pod.upravitPrispevek': 'I-edit ang post',
  'pod.upravtePrispevek': 'I-edit ang alok o hinahanap mo.',
  'pod.nabizimP': 'Inaalok ko *',
  'pod.hledamPotrebuji': 'Hinahanap ko / kailangan ko',
  'pod.coNabizitePriklad': 'Ano ang inaalok mo…',
  'pod.coHledatePriklad': 'Ano ang hinahanap mo…',
  'pod.ulozitZmeny': 'I-save ang mga pagbabago',
  'pod.vytvorenoPoptavka': 'Nagawa ang hinahanap.',
  'pod.vytvorenoNabidka': 'Nagawa ang alok.',
  'pod.chybaVytvorit': 'Hindi nagawa ang post',
  'pod.opravduSmazat': 'Buburahin ang alok na ito?',
  'pod.smazano': 'Nabura',
  'pod.chybaSmazat': 'Hindi ito nabura',
  'pod.aktualizovano': 'Na-update ang post.',
  'pod.chybaUlozit': 'Hindi ito na-save',
  'pod.zpravaOdeslana': 'Naipadala ang mensahe.',
  'pod.chybaOdeslat': 'Hindi naipadala ang mensahe',
  'obecne.hledatPriklad': 'Maghanap…',
  'obecne.upravit': 'I-edit',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Maghanap ng beripikadong propesyonal na makakatulong sa iyo sa daan mo',
  'odb.hledatPriklad': 'Maghanap ayon sa pangalan o lungsod…',
  'odb.vsechnyObory': 'Lahat ng larangan',
  'odb.radit': 'Ayusin:',
  'odb.vychozi': 'Karaniwan',
  'odb.nejvyssiHodnoceni': '★ Pinakamataas ang rating',
  'odb.nejnizsiHodnoceni': '★ Pinakamababa ang rating',
  'odb.zadniNalezeni': 'Walang nahanap na propesyonal',
  'odb.zkusteFiltry': 'Subukang baguhin ang mga filter',
  'odb.recenzi': () => 'review',
  'odb.dostupnyV': 'Available sa:',
  'odb.otevritVMapach': 'Buksan sa mapa',
  'odb.pridatRecenzi': 'Magdagdag ng review',
  'odb.ohodnotte': 'Bigyan ng rating ang karanasan mo sa propesyonal na ito.',
  'odb.vaseHodnoceni': 'Ang rating mo *',
  'odb.popisZkusenosti': 'Ilarawan ang karanasan mo',
  'odb.popisteZkusenost': 'Ilarawan ang karanasan mo…',
  'odb.odeslatRecenzi': 'Ipadala ang review',
  'odb.recenze': (p) => `Mga review (${p.pocet})`,
  'odb.zadneRecenze': 'Wala pang review. Maging una.',
  'odb.vyberteOdbornika': 'Pumili ng propesyonal para makita ang mga detalye at ang mapa',
  'odb.pridatOdbornika': 'Magdagdag ng propesyonal',
  'odb.pridejteOdbornika': 'Magdagdag ng bagong beripikadong propesyonal sa listahan.',
  'odb.navrhnout': 'Magmungkahi ng propesyonal',
  'odb.navrhnetePopis': 'Magmungkahi ng propesyonal na aaprubahan ng mga administrator.',
  'odb.navrhVysvetleni': 'Ipapadala ang suhestiyon mo sa mga administrator. Kapag naaprubahan na, lalabas ito sa listahan.',
  'odb.overEmail': 'Kumpirmahin ang email mo para makapagmungkahi ng propesyonal',
  'odb.jmeno': 'Pangalan *',
  'odb.kategorie': 'Kategorya *',
  'odb.popis': 'Paglalarawan',
  'odb.popisPriklad': 'Espesyalisasyon, karanasan…',
  'odb.adresa': 'Address *',
  'odb.mesto': 'Lungsod *',
  'odb.kraj': 'Rehiyon',
  'odb.vyber': 'Pumili',
  'odb.stat': 'Bansa',
  'odb.cesko': 'Czechia',
  'odb.telefon': 'Telepono',
  'odb.web': 'Website',
  'odb.odesilam': 'Ipinapadala…',
  'odb.odeslatKeSchvaleni': 'Ipadala para aprubahan',
  'odb.recenzePridana': 'Naidagdag ang review.',
  'odb.chybaRecenze': 'Hindi naidagdag ang review',
  'odb.odeslanKeSchvaleni': 'Naipadala ang propesyonal para aprubahan.',
  'odb.chybaOdeslat': 'Hindi naipadala ang propesyonal',
  'odb.pridan': 'Naidagdag ang propesyonal.',
  'odb.chybaPridat': 'Hindi ito naidagdag',
  'odb.polozitOtazku': 'Magtanong',
  'odb.novaOtazka': 'Bagong tanong para sa mga propesyonal',
  'odb.naCoSeZeptat': 'Ano ang gusto mong itanong sa mga propesyonal?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Impormasyon at suporta para sa trans community',
  'prav.zpetNaPoradnu': 'Balik sa Legal na tulong',
  'prav.clankyAPruvodci': 'Mga artikulo at gabay',
  'prav.pridatClanek': 'Magdagdag ng artikulo',
  'prav.novyClanek': 'Bagong artikulo',
  'prav.vytvorteClanek': 'Sumulat ng bagong artikulo para sa seksyong legal.',
  'prav.nazev': 'Pamagat *',
  'prav.kategorie': 'Kategorya',
  'prav.publikovatIhned': 'Ilathala agad',
  'prav.publikovano': 'Nailathala',
  'prav.obsah': 'Nilalaman *',
  'prav.obsahPriklad': 'Nilalaman ng artikulo…',
  'prav.zadneClanky': 'Walang artikulo sa kategoryang ito',
  'prav.skryto': 'Nakatago',
  'prav.skryt': 'Itago',
  'prav.publikovat': 'Ilathala',
  'prav.upravitClanek': 'I-edit ang artikulo',
  'prav.upravteObsah': 'I-edit ang nilalaman ng artikulong ito.',
  'prav.clanekPridan': 'Naidagdag ang artikulo.',
  'prav.chybaPridat': 'Hindi naidagdag ang artikulo',
  'prav.clanekUpraven': 'Na-update ang artikulo.',
  'prav.opravduSmazat': 'Buburahin ang artikulong ito?',
  'prav.chybaStav': 'Hindi napalitan ang katayuan',
  'prav.pridatOtazku': 'Magdagdag ng tanong',
  'prav.novaOtazka': 'Bagong tanong',
  'prav.naCoSeZeptat': 'Ano ang gusto mong itanong?',
  'obecne.vse': 'Lahat',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Balita mula sa mundong trans',
  'akt.prehratVideo': 'I-play ang video',
  'akt.obrazekVClanku': 'Larawan sa artikulo',
  'akt.clanekNenalezen': 'Hindi nahanap ang artikulo',
  'akt.zpetNaAktuality': 'Balik sa balita',
  'akt.autor': (p) => `May-akda: ${p.kdo}`,
  'akt.osobniPribeh': 'Personal na kuwento',
  'akt.upravitClanek': 'I-edit ang artikulo',
  'akt.komentare': (p) => `Mga komento (${p.pocet})`,
  'akt.zadneKomentare': 'Wala pang komento. Maging una.',
  'akt.pridatKomentar': 'Magdagdag ng komento…',
  'akt.proKomentovaniOverte': 'Kumpirmahin ang email mo para makapagkomento.',
  'akt.profil': 'Profile',
  'akt.prihlasteSeProKomentovani': 'Mag-sign in para makapagkomento.',
  'akt.upravteObsah': 'I-edit ang nilalaman ng artikulong ito.',
  'akt.nadpisP': 'Pamagat *',
  'akt.nadpis': 'Pamagat',
  'akt.obsahP': 'Nilalaman *',
  'akt.textClanku': 'Teksto ng artikulo…',
  'akt.obrazekUrlNeboSoubor': 'Larawan (URL o file)',
  'akt.videoUrlNeboSoubor': 'Video (URL o file)',
  'akt.ukladam': 'Sine-save…',
  'akt.novaAktualita': 'Bagong artikulo',
  'akt.sdiletPribeh': 'Magbahagi ng kuwento',
  'akt.vytvoritAktualitu': 'Sumulat ng artikulo',
  'akt.sdiletZkusenost': 'Magbahagi ng karanasan',
  'akt.napisteAktualitu': 'Sumulat ng bagong artikulo para sa komunidad.',
  'akt.podelteSe': 'Ibahagi ang karanasan mo sa komunidad.',
  'akt.obrazek': 'Larawan',
  'akt.nahratObrazek': 'Mag-upload ng larawan…',
  'akt.nahratVideo': 'Mag-upload ng video…',
  'akt.neboUrl': 'o isang URL:',
  'akt.textAktuality': 'Teksto ng artikulo…',
  'akt.sdilejtePribeh': 'Ibahagi ang kuwento o karanasan mo sa komunidad…',
  'akt.nahravam': 'Ina-upload…',
  'akt.publikovat': 'Ilathala',
  'akt.zkusenostiTucne': 'Mga personal na karanasan ng mga miyembro ng komunidad.',
  'akt.zkusenostiPopis': 'Ang seksyong ito ay para sa pagbabahagi ng karanasan sa buhay at mga kuwento. Puwedeng may teksto, larawan o video ang mga post.',
  'akt.sdiletSvujPribeh': 'Ibahagi ang kuwento mo',
  'akt.zadneAktuality': 'Walang balita',
  'akt.zadneVKategorii': 'Wala pang laman ang kategoryang ito',
  'akt.publikovan': 'Nailathala ang post.',
  'akt.chybaPublikovat': 'Hindi ito nailathala',
  'akt.opravduSmazat': 'Buburahin ang post na ito?',
  'akt.chyba': 'May hindi nagtama',
  'akt.chybaKomentar': 'Hindi naidagdag ang komento',
  'akt.chybaSmazatKomentar': 'Hindi nabura ang komento',
  'akt.aktualizovan': 'Na-update ang post.',
  'obecne.smazat': 'Burahin',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Iniisip ko ang transition',
  'faze.thinking.popis': 'Inaalam ko kung sino ako at kung aling landas ang akin.',
  'faze.research': 'Naghahanap ako ng impormasyon',
  'faze.research.popis': 'Nagbabasa, nagtatanong, naghahanap ng pinagkukunan at komunidad.',
  'faze.therapist': 'Unang pagpunta sa therapist',
  'faze.therapist.popis': 'Kinakausap ko ang isang propesyonal tungkol sa landas ko.',
  'faze.hormones': 'Hormone therapy',
  'faze.hormones.popis': 'Sinisimulan o ipinagpapatuloy ko ang hormone therapy.',
  'faze.documents': 'Pagpapalit ng mga dokumento',
  'faze.documents.popis': 'Inaayos ko ang legal na pagpapalit ng pangalan o kasarian.',
  'faze.cosmetic': 'Hitsura at pag-aayos',
  'faze.cosmetic.popis': 'Inaayos ko ang hitsura ko – buhok, make-up, istilo.',
  'faze.surgery-thinking': 'Pinag-iisipan ko ang operasyon',
  'faze.surgery-thinking.popis': 'Tinitimbang ko ang mga opsyon sa operasyon.',
  'faze.surgery': 'Pagkatapos ng operasyon',
  'faze.surgery.popis': 'Sumailalim na ako sa isa o higit pang operasyon.',
  'faze.stable': 'Nakaayos na',
  'faze.stable.popis': 'Nasa gusto ko nang kinalalagyan, at nabubuhay ako sa buhay ko.',
  'faze.individual': 'Sarili kong landas',
  'faze.individual.popis': 'Hindi kasya sa anumang kahon ang landas ko – at ayos lang iyon.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Dito ibinabahagi ang mga kuwento.',
  'zk.pribehNenalezen': 'Hindi nahanap ang kuwento',
  'zk.zpetNaPribehy': 'Balik sa mga kuwento',
  'zk.komunita': 'Ang komunidad',
  'zk.pribeh': 'Kuwento',
  'zk.upravitPribeh': 'I-edit ang kuwento',
  'zk.upravtePribeh': 'I-edit ang kuwentong ibinahagi mo.',
  'zk.textPribehu': 'Teksto ng kuwento…',
  'zk.fazeTranzice': 'Yugto ng transition',
  'zk.neuvadet': 'Hindi sasabihin',
  'zk.ukazeSeLidem': 'Ipapakita ang kuwento sa mga taong nagbabasa ng gabay para sa yugtong iyon.',
  'zk.sdiletPribeh': 'Magbahagi ng kuwento',
  'zk.overEmail': 'Kumpirmahin ang email mo para makapagbahagi ng kuwento',
  'zk.zadnePribehy': 'Wala pang kuwento. Maging una.',
  'zk.nazevPribehu': 'Ang pamagat ng kuwento mo…',
  'zk.pribehP': 'Kuwento *',
  'zk.sdilejteZkusenost': 'Ibahagi ang karanasan mo sa komunidad…',
  'zk.chybaNacist': 'Hindi na-load ang mga kuwento',
  'zk.vyplnteNadpis': 'Punan ang pamagat at ang teksto',
  'zk.spatnyOdkaz': 'Kailangang magsimula ang link ng larawan sa http://, https:// o /',
  'zk.sdilen': 'Naibahagi ang kuwento.',
  'zk.chybaSdilet': 'Hindi ito naibahagi',
  'zk.opravduSmazat': 'Buburahin ang kuwentong ito?',
  'zk.smazan': 'Nabura ang kuwento',
  'zk.aktualizovan': 'Na-update ang kuwento.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Hindi pa nakumpirma ang email mo. Pakikumpirma ito.',
  'ram.odesilam': 'Ipinapadala…',
  'ram.znovuOdeslat': 'Ipadala ulit',
  'ram.chceteUpozorneni': 'Gusto mo bang may abiso para sa mga bagong mensahe?',
  'ram.tedNe': 'Hindi muna',
  'ram.paticka': '© 2026 Bloom – pribadong espasyo para sa trans community',
  'ram.zasadyKomunity': 'Mga alituntunin ng komunidad',
  'ram.prekladNeovereny': 'Wala pang nagbabasa ng pagsasaling ito na nagsasalita ng wikang ito. Kung may tunog na mali, sabihin sa amin.',
  'ram.nahlasitProblem': 'Mag-ulat ng problema',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administrator',
  'ot.overenyPravnik': 'Beripikadong abogado',
  'ot.overenyOdbornik': 'Beripikadong propesyonal',
  'ot.odznakJinaZeme': (p) => `Ang badge na ito ay para lang sa: ${p.zeme}`,
  'ot.otazkyKomunity': 'Mga tanong ng komunidad',
  'ot.pridatOtazku': 'Magdagdag ng tanong',
  'ot.novaOtazka': 'Bagong tanong',
  'ot.naCoSeZeptat': 'Ano ang gusto mong itanong?',
  'ot.otazkaSeZobrazi': 'Ipapakita ang tanong mo sa ibang miyembro, at puwede nila itong sagutin.',
  'ot.otazkaP': 'Tanong *',
  'ot.oblastTema': 'Larangan / paksa',
  'ot.vseObecna': 'Kahit ano (pangkalahatang tanong)',
  'ot.odeslatOtazku': 'Ipadala ang tanong',
  'ot.overEmail': 'Kumpirmahin ang email mo para makapagdagdag ng tanong',
  'ot.zadneOtazky': 'Wala pang tanong. Maging una.',
  'ot.hlasu': () => 'boto',
  'ot.odpovedi': () => 'sagot',
  'ot.zadneOdpovedi': 'Wala pang sagot.',
  'ot.napisteOdpoved': 'Sumulat ng sagot…',
  'ot.jenPravnici': 'Ang mga tanong sa Legal na tulong ay sinasagot ng mga beripikadong abogado at administrator.',
  'ot.smazatOtazku': 'Buburahin ang tanong na ito?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Mga alok at hinahanap',
  'cp.zadneNabidky': 'Walang alok',
  'cp.napsatZpravu': 'Magpadala ng mensahe',
  'cp.nahlasitUzivatele': 'I-ulat ang miyembro',
  'cp.nahlasitKoho': (p) => `I-ulat si ${p.kdo}`,
  'cp.popisteDuvod': 'Ilarawan kung bakit mo ito iniuulat. Makikita ito ng mga administrator.',
  'cp.zustaneteAnonymni': 'Tatanggapin ng administrator ang ulat. Mananatili kang anonymous.',
  'cp.duvodP': 'Dahilan *',
  'cp.vybertDuvod': 'Pumili ng dahilan…',
  'cp.nevhodneChovani': 'Hindi angkop na pag-uugali',
  'cp.falesnyProfil': 'Pekeng profile',
  'cp.jinyProblem': 'Ibang problema',
  'cp.popisVolitelny': 'Paglalarawan',
  'cp.volitelny': '(opsyonal)',
  'cp.popisteSituaci': 'Ilarawan nang mas detalyado ang sitwasyon…',
  'cp.odeslatNahlaseni': 'Ipadala ang ulat',
  'cp.vyberteDuvodChyba': 'Pumili ng dahilan ng pag-uulat',
  'cp.nahlaseniOdeslano': 'Naipadala na ang ulat sa isang administrator',
  'cp.chybaNahlaseni': 'Hindi naipadala ang ulat',
  'gal.chranenoHeslem': 'Protektado ng password',
  'gal.soukromi': 'Privacy',
  'gal.nahravam': 'Ina-upload…',
  'gal.pridatFotku': 'Magdagdag ng larawan',
  'gal.nastaveniSoukromi': 'Mga setting ng privacy ng gallery',
  'gal.verejna': 'Pampubliko',
  'gal.chranenaHeslem': 'Protektado ng password',
  'gal.jeChranena': 'Protektado ng password ang gallery na ito',
  'gal.zadneFotky': 'Wala pang larawan. Magdagdag ng una mo.',
  'gal.otagovat': 'Mag-tag ng miyembro',
  'gal.hledatUzivatele': 'Maghanap ng miyembro…',
  'gal.odemcena': 'Nakabukas na ang gallery',
  'gal.spatneHeslo': 'Maling password ng gallery',
  'gal.nastaveniUlozeno': 'Na-save ang mga setting ng gallery',
  'gal.fotkaNahrana': 'Na-upload ang larawan.',
  'gal.chybaNahrat': 'Hindi na-upload ang larawan',
  'gal.fotkaSmazana': 'Nabura ang larawan',
  'gal.jizOtagovan': 'Naka-tag na ang miyembrong iyon',
  'gal.otagovan': (p) => `Na-tag: ${p.kdo}`,
  'gal.chybaTag': 'Hindi naidagdag ang tag',

  'ram.povolit': 'Payagan',
  'ram.oProjektu': 'Tungkol sa',
  'ram.kontakt': 'Kontak',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Mapa ng mundo – i-click ang isang bansa para buksan ito',
  'mapa.priblizit': 'Mag-zoom in',
  'mapa.oddalit': 'Mag-zoom out',
  'mapa.celySvet': 'Balik sa buong mundo',
  'mapa.chybaNacteni': 'Hindi na-load ang mapa',
  'mapa.chybaZkusteSeznam': 'Hindi na-load ang mapa. Subukan ang listahan ng mga bansa sa ibaba.',
  'mapa.teprveRoste': 'Nagsisimula pa lang ang Bloom dito',
  'mapa.napovedaDotyk': 'I-drag para igalaw ang mapa; mag-zoom sa pamamagitan ng kurot, dobleng tap, o mga button. Hindi mo kailangang gamitin ito — nasa ibaba ang paghahanap at ang buong listahan ng mga bansa.',
  'obsah.specialists': () => 'propesyonal',
  'obsah.organizations': () => 'organisasyon',
  'obsah.events': () => 'kaganapan',
  'obsah.pageants': () => 'pageant',
  'obsah.resources': () => 'sanggunian',
  'obsah.zaznamu': (p) => `${p.pocet} entry`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Saan ang tahanan mo?',
  'domov.popis': 'Ipapakita sa iyo ng Bloom ang malapit sa iyo. Puwede kang maglibot sa kahit anong bansa — hindi nito babaguhin '
      + 'ang bansang tahanan mo. Hindi ito kailanman ginagawang pampubliko at puwede mo itong palitan anumang oras.',
  'domov.preskocit': 'Laktawan',
  'domov.najitZemi': 'Maghanap ng bansa…',
  'domov.nicNeodpovida': 'Walang tumutugma. Subukan ang ibang paghahanap.',
  'domov.klikniDoMapy': 'Puwede mo ring i-click ang bansa sa mapa sa itaas.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Post',
  'typ.users': 'Miyembro',
  'typ.specialists': 'Propesyonal',
  'typ.services': 'Alok',
  'typ.articles': 'Legal na tulong',
  'typ.questions': 'Tanong ng komunidad',
  'typ.reviews': 'Review ng propesyonal',
  'nav.emailNeoveren': 'Hindi nakumpirma ang email',
  'nav.neovereny': 'Hindi beripikado',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'May sira',
  'chyba.navrh': 'Isang suhestiyon',
  'chyba.bezpecnost': 'Problema sa seguridad',
  'chyba.jiny': 'Iba pang bagay',
  'chyba.vyberteTyp': 'Pumili ng uri ng problema',
  'chyba.popisteProsim': 'Pakilarawan ang problema',
  'chyba.odeslano': 'Naipadala ang ulat, salamat.',
  'chyba.chybaOdeslat': 'Hindi naipadala ang ulat',
  'chyba.napisteNam': 'Sabihin sa amin kung ano ang nangyari — nakakatulong ito para maayos namin.',
  'chyba.typProblemu': 'Uri ng problema',
  'chyba.popisProblemu': 'Ano ang nangyari',
  'chyba.popisPriklad': 'Ilarawan kung ano ang nangyari, ano ang inaasahan mo at ano ang nangyari sa halip…',
  'chyba.priloha': 'Kusa naming ikinakabit: ang kasalukuyang page, ang oras at impormasyon tungkol sa browser mo.',
  'chyba.odeslatHlaseni': 'Ipadala ang ulat',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Isulat ang nilalaman…',
  'ed.tucne': 'Bold (Ctrl+B)',
  'ed.kurziva': 'Italic (Ctrl+I)',
  'ed.odrazky': 'Listahang may bullet',
  'ed.vlozitOdkaz': 'Maglagay ng link',
  'ed.vlozitTabulku': 'Maglagay ng talahanayan',
  'ed.radky': 'Mga hilera',
  'ed.sloupce': 'Mga hanay',
  'ed.vlozit': 'Ilagay',
  'ed.barva.cerna': 'Itim',
  'ed.barva.seda': 'Abo',
  'ed.barva.fialova': 'Lila',
  'ed.barva.ruzova': 'Rosas',
  'ed.barva.modra': 'Asul',
  'ed.barva.zelena': 'Berde',
  'ed.barva.cervena': 'Pula',
  'ed.barva.oranzova': 'Kahel',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Hindi balido ang link ng kumpirmasyon na iyon.',
  'over.hotovo': 'Nakumpirma na ang email mo.',
  'over.odkazVyprsel': 'Hindi balido o nag-expire na ang link ng kumpirmasyon.',
  'over.overuji': 'Kinukumpirma ang email mo…',
  'over.cekejte': 'Sandali lang.',
  'over.overen': 'Nakumpirma ang email.',
  'over.plnyPristup': 'May buo ka nang akses sa lahat ng nasa Bloom.',
  'over.prejitNaBloom': 'Pumunta sa Bloom',
  'over.selhalo': 'Hindi natuloy ang kumpirmasyon',
  'over.zpetNaPrihlaseni': 'Balik sa pag-sign in',
  'oauth.ucetNenalezen': 'Hindi nahanap ang account',
  'oauth.neexistujeGoogle': 'Walang Bloom account para sa Google account na ito. Mag-sign up muna.',
  'oauth.neexistujeFacebook': 'Walang Bloom account para sa Facebook account na ito. Mag-sign up muna.',
  'oauth.registrovatGoogle': 'Mag-sign up gamit ang Google',
  'oauth.registrovatFacebook': 'Mag-sign up gamit ang Facebook',
  'oauth.prihlasujiGoogle': 'Nagsa-sign in gamit ang Google…',
  'oauth.prihlasujiFacebook': 'Nagsa-sign in gamit ang Facebook…',
  'oauth.facebookSelhalo': 'Hindi natuloy ang pag-sign in gamit ang Facebook',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Naglo-load…',
  'obecne.nezadano': '— hindi nakalagay —',
  'obecne.neplatnaHodnota': 'Hindi balido ang halagang iyon.',
  'obecne.strankovani': 'Pagnu-numero ng page',
  'navrh.doplnteNazev': 'Pakipunan ang pangalan.',
  'navrh.vyberteZemi': 'Pumili ng bansa.',
  'navrh.doplnte': (p) => `Pakipunan: ${p.co}.`,
  'kat.overenoZaznam': 'Nasuri na tumutugma sa totoo ang entry na ito',
  'kat.prihlaskyDo': (p) => `Tumatanggap ng aplikasyon hanggang ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profile',
  'profil.zalozkaGalerie': 'Gallery',
  'pf.lokalita': 'Lokasyon',

  'cesta.legendaBarev': 'Susi ng mga kulay',

  'hled.pocetVysledku': (p) => `(${p.pocet} resulta)`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Mahabang blondeng buhok',
  'avatar.fem-lavender': 'Lilang buhok',
  'avatar.fem-peach': 'Bob na may bangs',
  'avatar.fem-dark': 'Mahabang maitim na buhok',
  'avatar.fem-straight': 'Pulang buhok',
  'avatar.fem-ponytail': 'Ponytail',
  'avatar.masc-blue': 'Maikling blondeng buhok',
  'avatar.masc-teal': 'Gusot na buhok',
  'avatar.masc-gray': 'Kulay-abong buhok',
  'avatar.masc-short': 'Kalbo-gupit',
  'avatar.nb-mint': 'Buhok na mint',
  'avatar.nb-lilac': 'Pusod sa itaas',
  'avatar.nb-curly': 'Maiikling kulot',
  'avatar.nb-sage': 'Buhok hanggang balikat',
  'avatar.nb-mohawk': 'Mohawk',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Ahit na ulo',
  'avatar.nb-glasses': 'Salamin',
  'avatar.animal-cat': 'Pusa',
  'avatar.animal-fox': 'Soro',
  'avatar.animal-rabbit': 'Kuneho',
  'avatar.sym-flower': 'Bulaklak',
  'avatar.sym-butterfly': 'Paruparo',
  'avatar.sym-star': 'Bituin',
  'avatar.custom': 'Mag-upload ng sarili mong larawan',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Ni-log out ka namin pagkatapos ng ilang sandaling walang ginagawa.',
  'odhl.necinnostPopis': 'Hindi ka iniiwang naka-sign in ng Bloom kapag walang tao roon.',
  'odhl.zaChvili': 'Ilalabas ka namin sa ilang sandali',
  'odhl.zaChviliPopis': 'Hawakan ang screen o ang keyboard anumang oras at mananatili kang naka-sign in.',

  'reg.avatarSymboly': 'Mga simbolo',

  'avatar.fem-bun': 'Pusod',
  'avatar.masc-navy': 'Buong balbas',
  'avatar.masc-brown': 'Hati sa gilid',
  'avatar.masc-goatee': 'Balbas sa baba',
  'avatar.nb-freckles': 'Mga pekas',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Kuwago',
  'avatar.sym-rainbow': 'Bahaghari',
  'avatar.sym-heart': 'Puso',
  'avatar.sym-lotus': 'Lotus (Bloom)',

  'reg.potvrditHeslo': 'Kumpirmahin ang password',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Gumawa',
  'obecne.sdilet': 'Ibahagi',
  'obecne.opravneni': 'Pahintulot',
  'obecne.pristupGalerie': 'Kailangan namin ng access sa iyong gallery para mag-upload ng larawan.',
  'obecne.vsechnyRegiony': 'Lahat ng rehiyon',
  'obecne.cesko': 'Czechia',
  'obecne.odbornici': 'Mga propesyonal',
  'obecne.zadnaZprava': 'Walang mensahe',
  'ucet.vyplnteEmailHeslo': 'Ilagay ang e-mail at password',
  'ucet.spatneUdaje': 'Mali ang e-mail o password',
  'ucet.googleSelhalo': 'Nabigo ang pag-sign in gamit ang Google',
  'ucet.skrytHeslo': 'Itago ang password',
  'ucet.emailOveren': 'Na-verify na ang iyong e-mail.',
  'ucet.emailPriklad': 'ikaw@email.com',
  'ucet.overeniSelhalo': 'Nabigo ang pag-verify.',
  'ucet.overeniSelhaloZnovu': 'Nabigo ang pag-verify. Subukan ulit.',
  'ucet.komunitniHesloPovinne': 'Kailangan ang community password',
  'ucet.zadejteKomunitniHeslo': 'Ilagay ang community password…',
  'ucet.komunitniHesloPopis': 'Pribadong espasyo ang Bloom. May makakapagbigay sa iyo ng password mula sa komunidad.',
  'ucet.prezdivkaMin3': 'Dapat hindi bababa sa 3 karakter ang display name',
  'ucet.vyplntePrezdivku': 'Maglagay ng display name',
  'ucet.vasePrezdivka': 'Ang iyong display name',
  'ucet.profilNeulozen': 'Hindi na-save ang profile',
  'ucet.anoZrusitProfil': 'Oo, burahin ang profile ko',
  'heslo.min8': 'Dapat hindi bababa sa 8 karakter ang password',
  'heslo.maleP': 'Dapat may maliit na titik ang password',
  'heslo.velkeP': 'Dapat may malaking titik ang password',
  'heslo.cislo': 'Dapat may numero ang password',
  'heslo.specialni': 'Dapat may espesyal na karakter ang password',
  'heslo.specialniPriklad': 'Dapat may espesyal na karakter ang password (!@#$%)',
  'heslo.napoveda': 'Min. 8 karakter, malaking titik, numero, espesyal',
  'profil.oSobe': 'Maikling tungkol sa iyo…',
  'profil.zajmenaOna': 'siya (babae)',
  'profil.zajmenaJine': 'iba',
  'profil.doplnujiciText': 'Opsyonal na karagdagang teksto…',
  'profil.prikladOboru': 'hal. plastic surgery, family law…',
  'komunita.soukromiNadpis': 'Pinoprotektahan namin ang privacy',
  'komunita.soukromiText': 'Ang ibinabahagi sa Bloom ay nananatili sa Bloom.',
  'komunita.podporaText': 'Ang Bloom ay tungkol sa pagtutulungan.',
  'komunita.neniObchod': 'Hindi marketplace ang Bloom.',
  'komunita.zadneObtezovani': 'Walang puwang sa Bloom ang anumang uri ng panghaharas.',
  'komunita.oslovovani': 'Tinatawag namin ang bawat isa sa pangalan at panghalip na ginagamit nila.',
  'komunita.jakakolivEtapa': 'Nasaan ka man sa iyong paglalakbay.',
  'prav.kategZdravi': 'Kalusugan',
  'prav.kategPravni': 'Legal',
  'prav.kategSocialni': 'Panlipunan',
  'ot.chybaOdpoved': 'Hindi naipadala ang sagot.',
  'ot.chybaOtazka': 'Hindi naidagdag ang tanong.',
  'zk.napisteKomentar': 'Magsulat ng komento…',
  'zpr.chybaHlasova': 'Hindi na-upload ang voice message. Server:',
  'zpr.chybaObrazek': 'Hindi na-upload ang larawan. Server:',
  'pod.nabizim': 'Nag-aalok',
  'pod.coHledate': 'Ano ang hinahanap mo? (hal. masahe, potograpiya…)',
  'pod.coNabizite': 'Ano ang inaalok mo? (hal. pagluluto, paggupit…)',
  'pod.lokalitaVolitelna': 'Lokasyon (opsyonal)',
  'pod.podrobnejsiPopis': 'Mas detalyadong paglalarawan *',
  'pod.vyplnteHledate': 'Isulat kung ano ang hinahanap mo.',
  'pod.vyplnteNabizite': 'Isulat kung ano ang inaalok mo.',
  'pod.vyplntePopis': 'Magdagdag ng paglalarawan.',
  'pod.zadnePrispevky': 'Wala ka pang post. Gumawa ng alok o hiling.',
  'svet.vybratZemi': 'Pumili ng bansa',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Magtanong',
  'ot.nadpis': 'Mga tanong at sagot',
  'zk.pridat': 'Magdagdag ng kuwento',
  'zk.novy': 'Bagong kuwento',
  'zk.smazat': 'Burahin ang kuwento',
  'zk.zadne': 'Wala pang kuwento. Ikaw na ang mauna.',
  'akt.zadne': 'Wala pang balita.',
  'nav.clanky': 'Mga artikulo',
  'ucet.emailOdeslan': 'Naipadala ang e-mail',
  'ucet.komunitniHeslo': 'Community password',
  'ucet.nemateUcet': 'Wala ka pang account? Mag-sign up',
  'ucet.muzetePrihlasit': 'Puwede ka nang mag-sign in.',
  'ucet.zapomenutePopis': 'Ilagay ang e-mail at padadalhan ka namin ng link para i-reset ang password.',
  'profil.oMneVolitelne': 'Tungkol sa akin (opsyonal)',
  'profil.prezdivka': 'Display name',
  'profil.telefonVolitelne': 'Telepono (opsyonal)',
  'cesta.poznamkaVolitelna': 'Personal na tala (opsyonal)',
  'okoli.vyberteLokalitu': 'Pumili ng lokasyon sa itaas',
  'hled.nadpis': 'Paghahanap',
  'hled.popis': 'Maghanap sa buong app – mga tao, artikulo, kuwento, review…',
  'hled.min2': 'Mag-type ng hindi bababa sa 2 karakter para maghanap',
  'pod.vsechnySluzby': 'Lahat ng serbisyo',
  'domu.clenoveKomunity': 'Mga miyembro ng komunidad',
  'zpr.zadneKonverzaceHledat': 'Wala pang usapan. Maghanap ng tao sa itaas.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'siya (lalaki)',
  'reg.zajmenaOni': 'sila',
  'reg.zajmenaOno': 'ito',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Burahin ang larawan',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Maglagay ng password para sa gallery',
  'reg.min3znaky': 'Min. 3 karakter',
  'reg.zopakujteHeslo': 'Ulitin ang password',
  'hled.vBloom': 'Maghanap sa Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'I-edit ang profile',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Pumili ng rehiyon',
  'obecne.region': 'Rehiyon',
  'gal.heslemChranena': 'Protektado ng password',
  'gal.hesloGalerie': 'Password ng gallery',
  'reset.nastavitHeslo': 'Itakda ang password',
  'reset.hesloObnoveno': 'Na-reset na ang password.',
  'profil.nenalezen': 'Hindi nahanap ang profile',
  'obecne.nebo': 'o',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Buksan ang iyong authenticator app at kopyahin ang anim na numero para sa Bloom. Puwede rin ang isa sa iyong backup codes.',
  'auth.sifrovaniNapoveda': 'Kung binuksan mo ang message encryption sa web, hindi pa makakapag-sign in ang app sa account na iyon. Gamitin ang bloomapp.cz sa browser.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Ipakita ang password',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Burahin ang larawang ito?',
  'dvf.zadejteKod': 'Ilagay ang code mula sa iyong app',
  'sif.odemknoutAplikaci': 'I-unlock ang app',
  'profil.odeslatZnovu': 'Ipadala ulit',
};

export default tl;
